<template>
  <div>
    <div class="modal fade" :id="modal_id" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true" data-backdrop="static" data-keyboard="false">
      <div class="modal-dialog modal-dialog-scrollable modal-dialog-total" role="document">
        <div class="modal-content modal-content-total" v-if="exibir">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">
              {{ ( ( edicao && !edicao[campo_chave] ) ? ( kit ? 'Novo' : 'Nova' ) : '' ) }}
              {{ title }}
              <span class="badge badge-secondary" v-if="edicao.nome_procedimento">{{ edicao.nome_procedimento }}</span>
              <span class="badge badge-secondary ml-3" v-if="edicao && edicao[campo_chave]">#{{ edicao[campo_chave] }}</span>

              <span v-if="atendimento && atendimento.paciente && atendimento.paciente.search" class="ml-3 text-muted">
                {{ atendimento.paciente.search }}
              </span>

              <small v-if="atendimento && atendimento.plano && atendimento.plano.search" class="ml-3 text-muted">
                <small>{{ atendimento.plano.search }}</small>
              </small>
              <template v-if="edicao.medico_edicao">
                <div class="small">
                    <span class="badge badge-success mr-1" v-if="edicao.tipo_edicao == 'P'">Prescrição do Protocolo</span>
                    <span class="badge badge-secondary">Editada por {{ edicao.medico_edicao.search }} em {{ edicao.dt_inclusao ? $util.getFormatDate(edicao.dt_inclusao) : '' }}</span>
                </div>
              </template>
              <template v-else-if="edicao.tipo_edicao == 'P'">
                <div class="small">
                    <span class="badge badge-success mr-1" v-if="edicao.tipo_edicao == 'P'">Prescrição do Protocolo</span>
                </div>
              </template>
            </h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col col-12" :class="id_paciente ? 'col-md-8' : ''">

                <div class="alert alert-danger" v-if="name == 'receita' && atendimento && atendimento.paciente && atendimento.paciente.alergias && atendimento.paciente.alergias.length">
                  <div class="lead">Alergias:</div>
                  <div v-for="(alergia, iax) in atendimento.paciente.alergias" :key="iax">
                    <strong>{{ alergia.tipo.search }}</strong>
                    <template v-if="alergia.st_observacoes">
                      <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>{{ alergia.st_observacoes }}
                    </template>
                  </div>
                </div>

                <template v-if="kit">
                  <div class="form-row mb-3">
                    <div class="col col-12" :class="name == 'receita' ? 'col-md-6' : ''">
                      <az-input
                        :placeholder="edicao.fl_ciclos ? 'Nome do Protocolo...' : 'Nome do Kit...'"
                        required
                        :validate="validate"
                        v-model="edicao.st_nome">
                        <template v-slot:buttonposb>
                          <div class="input-group-append">
                            <button class="btn" :class="habilita_ordem ? 'btn-secondary' : ' btn-outline-secondary'" type="button" id="button-addon2" @click="habilita_ordem = !habilita_ordem" title="Habilitar Ordenação.">
                              <i class="fas fa-sort"></i>
                            </button>

                            <button class="btn btn-outline-secondary" type="button" id="button-addon2" @click="ordenar('A')" title="Ordem Alfabética.">
                              <i class="fas fa-sort-alpha-down"></i>
                            </button>

                            <button class="btn btn-outline-secondary" type="button" id="button-addon2" @click="ordenar('L')" title="Ordem de Lançamento.">
                              <i class="fas fa-sort-numeric-down"></i>
                            </button>
                          </div>
                        </template>
                      </az-input>
                    </div>
                    <div class="col col-12 col-md-2" v-if="name == 'receita'">
                        <az-input
                            placeholder="Tipo..."
                            type="select"
                            :optionsList="edicao.fl_ciclos ? 
                            [
                                { id: 'G', search: 'Geral' },
                                { id: 'Q', search: 'Quimioterapia' },
                                { id: 'U', search: 'Reumatologia' },
                                { id: 'W', search: 'Reumatologia/Ciclo' },
                                { id: 'O', search: 'Outros' },
                            ]
                            : [
                                { id: 'G', search: 'Geral' },
                                { id: 'R', search: 'Receita' },
                                { id: 'P', search: 'Prescrição' },
                            ]"
                            optionsData="id"
                            required
                            :validate="validate"
                            v-model="edicao.st_tipo" />
                    </div>
                    <div class="col col-12 col-md-2" v-if="name == 'receita'">
                      <az-input
                        type="checkbox-group"
                        label="Infusão"
                        :edicao="false"
                        :validate="validate"
                        v-model="edicao.fl_ciclos" />
                    </div>
                    <div class="col col-12 col-md-2" v-if="name == 'receita'">
                      <az-input
                        placeholder="Id Externo..."
                        :validate="validate"
                        v-model="edicao.st_id_externo" />
                    </div>
                  </div>

                  <div v-if="edicao.fl_ciclos" class="mb-3">
                    <!-- Procedimento do Protocolo de Infusão -->
                    <div class="form-row">
                      <div class="col col-12">
                        <az-input
                          :compact="true"
                          sizing="sm"
                          type="select"
                          label="Procedimento"
                          service="procedimentos.index"
                          optionsMode="aql"
                          optionsData="id_procedimento"
                          :optionsParm="{ agenda: true, infusao: true }"
                          :validate="validate"
                          v-model="edicao.id_procedimento_protocolo" />
                      </div>
                    </div>

                    <!-- Informações do Protocolo de Infusão -->
                    <div class="form-row">
                      <template v-if="edicao.st_tipo == 'U'">
                        <div class="col col-12 col-md-3">
                          <az-input
                            sizing="sm"
                            type="number"
                            label="Intervalo entre as Sessões"
                            :validate="validate"
                            v-model="edicao.in_intervalo">
                            <template v-slot:buttonposb>
                              <div class="input-group-append">
                                <span class="input-group-text" id="basic-addon2">dia(s)</span>
                              </div>
                            </template>
                          </az-input>
                        </div>
                      </template>
                      <template v-else-if="edicao.st_tipo == 'Q' || edicao.st_tipo == 'W'">
                        <div class="col col-12 col-md-3">
                          <az-input
                            sizing="sm"
                            type="number"
                            label="Quantidade de Ciclos"
                            required
                            :validate="validate"
                            v-model="edicao.in_ciclos" />
                        </div>
                        <div class="col col-12 col-md-3">
                          <az-input
                            sizing="sm"
                            type="number"
                            label="Duração do Ciclo"
                            required
                            :validate="validate"
                            v-model="edicao.in_duracao">
                            <template v-slot:buttonposb>
                              <div class="input-group-append">
                                <span class="input-group-text" id="basic-addon2">dia(s)</span>
                              </div>
                            </template>
                          </az-input>
                        </div>
                        <div class="col col-12 col-md-3" v-if="edicao.in_ciclos > 1">
                          <az-input
                            sizing="sm"
                            type="number"
                            label="Intervalo entre os Ciclos"
                            :validate="validate"
                            v-model="edicao.in_intervalo">
                            <template v-slot:buttonposb>
                              <div class="input-group-append">
                                <span class="input-group-text" id="basic-addon2">dia(s)</span>
                              </div>
                            </template>
                          </az-input>
                        </div>
                      </template>
                      <div class="col col-12 col-md-3">
                        <az-input
                          sizing="sm"
                          type="number"
                          label="Duração da Sessão"
                          :validate="validate"
                          v-model="edicao.in_tempo_sessao">
                          <template v-slot:buttonposb>
                            <div class="input-group-append">
                              <span class="input-group-text" id="basic-addon2">minuto(s)</span>
                            </div>
                          </template>
                        </az-input>
                      </div>
                    </div>
                  </div>

                </template>

                <!-- Seleção de Prescrição de Infusão -->
                <template v-else-if="( tem_infusao || edicao.kit ) && name == 'receita' && edicao.fl_prescricao && edicao.fl_ciclos">
                  <div class="card" v-if="edicao.fl_ciclos">
                    <div class="card-header  py-2 alert-info d-flex justify-content-between">
                      <a class="card-link" data-toggle="collapse" href="#infoInfusao">
                        {{ edicao.st_tipo_receita == 'Q' ? 'Quimioterapia' : 'Infusão' }}
                      </a>
                      <span v-if="edicao.kit">
                        <strong>
                          {{ edicao.kit.search }}
                        </strong>
                        <a href="#" @click.prevent="edicao.ver_peso = !edicao.ver_peso" class="ml-3">
                          <i class="fa-solid fa-pen-ruler" v-if="!edicao.ver_peso"></i>
                          <i class="fa-solid fa-ruler" v-else></i>
                        </a>
                      </span>
                    </div>
                    <div class="card-body collapse show" id="infoInfusao">
                      <!-- Kit Infusão -->
                      <template v-if="edicao.fl_ciclos">
                        <div class="form-row">
                          <div class="col col-12">
                            <az-input
                              :compact="true"
                              sizing="sm"
                              type="select"
                              label="Procedimento"
                              service="procedimentos.index"
                              optionsMode="aql"
                              optionsData="id_procedimento"
                              :optionsParm="{ agenda: true, infusao: true }"
                              :validate="validate"
                              v-model="edicao.id_procedimento_protocolo" />
                          </div>
                        </div>

                        <template v-if="edicao.st_tipo_receita == 'U'">
                          <div class="form-row">
                            <div class="col col-12 col-md-3">
                              <az-input
                                sizing="sm"
                                type="number"
                                label="Intervalo entre as Sessões"
                                :validate="validate"
                                v-model="edicao.in_intervalo">
                                <template v-slot:buttonposb>
                                  <div class="input-group-append">
                                    <span class="input-group-text" id="basic-addon2">dia(s)</span>
                                  </div>
                                </template>
                              </az-input>
                            </div>
                            <div class="col col-12 col-md-3">
                              <az-input
                                sizing="sm"
                                type="number"
                                label="Duração da Sessão"
                                :validate="validate"
                                v-model="edicao.in_tempo_sessao">
                                <template v-slot:buttonposb>
                                  <div class="input-group-append">
                                    <span class="input-group-text" id="basic-addon2">minuto(s)</span>
                                  </div>
                                </template>
                              </az-input>
                            </div>
                          </div>

                        </template>

                        <template v-else-if="edicao.st_tipo_receita == 'Q'">

                          <div class="form-row">
                            <div class="col col-12 col-md-3">
                              <az-input
                                sizing="sm"
                                type="number"
                                label="Quantidade de Ciclos"
                                required
                                :validate="validate"
                                v-model="edicao.in_ciclos" />
                            </div>
                            <div class="col col-12 col-md-3">
                              <az-input
                                sizing="sm"
                                type="number"
                                label="Duração do Ciclo"
                                required
                                :validate="validate"
                                v-model="edicao.in_duracao">
                                <template v-slot:buttonposb>
                                  <div class="input-group-append">
                                    <span class="input-group-text" id="basic-addon2">dia(s)</span>
                                  </div>
                                </template>
                              </az-input>
                            </div>
                            <div class="col col-12 col-md-3" v-if="edicao.in_ciclos > 1">
                              <az-input
                                sizing="sm"
                                type="number"
                                label="Intervalo entre os Ciclos"
                                :validate="validate"
                                v-model="edicao.in_intervalo">
                                <template v-slot:buttonposb>
                                  <div class="input-group-append">
                                    <span class="input-group-text" id="basic-addon2">dia(s)</span>
                                  </div>
                                </template>
                              </az-input>
                            </div>
                            <div class="col col-12 col-md-3">
                              <az-input
                                sizing="sm"
                                type="number"
                                label="Duração da Sessão"
                                :validate="validate"
                                v-model="edicao.in_tempo_sessao">
                                <template v-slot:buttonposb>
                                  <div class="input-group-append">
                                    <span class="input-group-text" id="basic-addon2">minuto(s)</span>
                                  </div>
                                </template>
                              </az-input>
                            </div>
                          </div>
                        </template>

                        <template  v-if="edicao.ver_peso || edicao.in_peso">

                            <div class="form-row">
                                <div class="col col-12 col-md-3">
                                    <az-input
                                        sizing="sm"
                                        type="number"
                                        label="Peso"
                                        :validate="validate"
                                        v-model="edicao.in_peso">
                                        <template v-slot:buttonposb>
                                            <div class="input-group-append">
                                                <span class="input-group-text" id="basic-addon2">kg</span>
                                            </div>
                                        </template>
                                    </az-input>
                                </div>
                                <div class="col col-12 col-md-3">
                                    <az-input
                                        sizing="sm"
                                        type="number"
                                        label="Altura"
                                        :validate="validate"
                                        v-model="edicao.in_altura">
                                        <template v-slot:buttonposb>
                                            <div class="input-group-append">
                                                <span class="input-group-text" id="basic-addon2">m</span>
                                            </div>
                                        </template>
                                    </az-input>
                                </div>
                                <div class="col col-12 col-md-3">
                                    <az-input
                                        sizing="sm"
                                        type="number"
                                        label="Superfície Corpórea (SC)"
                                        :validate="validate"
                                        :edicao="false"
                                        v-model="sc">
                                        <template v-slot:buttonposb>
                                            <div class="input-group-append">
                                                <span class="input-group-text" id="basic-addon2">m2</span>
                                            </div>
                                        </template>
                                    </az-input>
                                </div>
                                <div class="col col-12 col-md-3">
                                    <az-input
                                        sizing="sm"
                                        type="number"
                                        label="Creatinina"
                                        :validate="validate"
                                        v-model="edicao.dc_creatinina">
                                        <template v-slot:buttonposb>
                                            <div class="input-group-append">
                                                <span class="input-group-text" id="basic-addon2">mg/dL</span>
                                                <a href="https://reference.medscape.com/calculator/169/carboplatin-auc-dosing-calvert" class="btn btn-outline-secondary" target="_blank">
                                                    <i class="fa fa-calculator" aria-hidden="true"></i>
                                                </a>
                                            </div>
                                        </template>
                                    </az-input>
                                </div>

                                <div class="col col-12 col-md-3" v-if="false">
                                    <az-input
                                        sizing="sm"
                                        type="number"
                                        label="IMC"
                                        :validate="validate"
                                        :edicao="false"
                                        v-model="imc" />
                                </div>
                            </div>

                            <div class="form-row" v-if="!( atendimento.marcacao && ( atendimento.marcacao.in_qt_dia || atendimento.marcacao.in_qt_ciclo ) )">
                                <div class="col col-12 col-md-3">
                                    <az-input
                                        sizing="sm"
                                        type="number"
                                        label="Ciclo"
                                        :validate="validate"
                                        v-model="edicao.in_qt_ciclo">
                                        <template v-slot:button-pre>
                                            <div class="input-group-prepend">
                                                <span class="input-group-text" id="basic-addon2">C</span>
                                            </div>
                                        </template>
                                    </az-input>
                                </div>

                                <div class="col col-12 col-md-3">
                                    <az-input
                                        sizing="sm"
                                        type="number"
                                        label="Dia"
                                        :validate="validate"
                                        v-model="edicao.in_qt_dia">
                                        <template v-slot:button-pre>
                                            <div class="input-group-prepend">
                                                <span class="input-group-text" id="basic-addon2">D</span>
                                            </div>
                                        </template>
                                    </az-input>
                                </div>

                                <div class="col col-12 col-md-3">
                                    <az-input
                                        sizing="sm"
                                        type="date"
                                        label="Início do Tratamento"
                                        :validate="validate"
                                        v-model="edicao.dt_qt_inicio">
                                    </az-input>
                                </div>
                            </div>

                        </template>
                        
                      </template>
                    </div>
                  </div>
                </template>
                <!-- Fim Infusão -->

                <!-- Prescrição Internação -->
                <template v-else-if="name == 'receita' && edicao.fl_prescricao && atendimento && atendimento.id_tipo_atendimento == 7">
                  <div class="form-row mb-3">
                    <div class="col col-12 col-md-3">
                        <az-input
                          sizing="sm"
                          type="number"
                          label="Duração"
                          placeholder="1..."
                          :validate="validate"
                          v-model="edicao.in_duracao">
                          <template v-slot:buttonposb>
                            <div class="input-group-append">
                              <span class="input-group-text" id="basic-addon2">dia(s)</span>
                            </div>
                          </template>
                        </az-input>
                      </div>
                  </div>
                </template>

                <div class="mb-3" v-if="name == 'requisicao' && edicao">

                  <div class="row">
                    <div class="col col-12">
                      <az-input
                        label="CID"
                        placeholder="CID Principal..."
                        sizing="sm"
                        type="autocomplete"
                        optionsMode="aql"
                        service="cids.index"
                        optionsDisplay="search"
                        v-model="edicao.cid"
                        :validate="validate">
                        <template v-slot:buttonposb>
                          <div class="input-group-append" v-if="edicao.cid2 === null">
                            <button class="btn btn-outline-primary" type="button" id="button-addon2"
                              @click="edicao.cid2 === null ? edicao.cid2 = '' : edicao.cid2 = null">
                              <i class="fa fa-plus mr-2" aria-hidden="true"></i>
                              Sec
                            </button>
                          </div>

                          <div class="input-group-append">
                            <button class="btn btn-outline-primary ml-2" type="button" id="button-addon2" @click="trocar_plano()" title="Alterar Operadora/Plano">
                              <i class="far fa-credit-card" aria-hidden="true"></i>
                            </button>

                            <button class="btn btn-outline-primary ml-2" type="button" id="button-addon2" @click="definir_particular()" title="Cobrança Particular">
                              <i class="fa-solid fa-dollar-sign"></i>
                            </button>
                          </div>
                        </template>
                      </az-input>
                    </div>
                  </div>

                  <div class="row" v-if="edicao.cid2 !== null">
                    <div class="col col-12">
                      <az-input
                        placeholder="CID Secundário..."
                        sizing="sm"
                        type="autocomplete"
                        optionsMode="aql"
                        service="cids.index"
                        optionsDisplay="search"
                        v-model="edicao.cid2"
                        :validate="validate">
                        <template v-slot:buttonposb>
                          <div class="input-group-append">
                            <button class="btn btn-outline-primary" type="button" id="button-addon2" @click="edicao.cid3 = ''" v-if="edicao.cid3 === null">
                              <i class="fa fa-plus fa-fw" aria-hidden="true"></i>
                            </button>
                            <button class="btn btn-outline-danger" type="button" id="button-addon2" @click="edicao.cid2 = null" :disabled="edicao.cid3 !== null">
                              <i class="fa fa-minus fa-fw" aria-hidden="true"></i>
                            </button>
                          </div>
                        </template>
                      </az-input>
                    </div>
                  </div>

                  <div class="row" v-if="edicao.cid3 !== null">
                    <div class="col col-12">
                      <az-input
                        placeholder="CID Secundário..."
                        sizing="sm"
                        type="autocomplete"
                        optionsMode="aql"
                        service="cids.index"
                        optionsDisplay="search"
                        v-model="edicao.cid3"
                        :validate="validate">
                        <template v-slot:buttonposb>
                          <div class="input-group-append">
                            <button class="btn btn-outline-danger" type="button" id="button-addon2" @click="edicao.cid3 = null">
                              <i class="fa fa-minus fa-fw" aria-hidden="true"></i>
                            </button>
                          </div>
                        </template>
                      </az-input>
                    </div>
                  </div>

                  <div class="row" v-if="edicao.plano !== null && edicao.plano !== undefined">
                    <div class="col col-12">
                      <az-input 
                          sizing="sm"
                          placeholder="Operadora/Plano..."
                          icon="far fa-credit-card"
                          type="autocomplete" 
                          optionsMode="aql"
                          optionsName="planos.atendimento"
                          :optionsParm="{ 
                            atendimento: true, 
                            plano_id_unidade_operacao: ( atendimento && atendimento.marcacao && atendimento.marcacao.id_unidade_operacao ) ? atendimento.marcacao.id_unidade_operacao : null,
                          }"
                          service="planos.index"
                          :optionsSync="false"
                          required
                          :validate="validate"
                          v-model="edicao.plano">
                      </az-input>
                    </div>
                  </div>
                </div>

                <div class="row mb-2" v-if="name == 'receita' && !edicao.fl_prescricao && edicao && !kit">
                  <div class="col col-12">
                    <az-input
                      label="Tipo de Receita"
                      sizing="sm"
                      type="select"
                      optionsMode="json"
                      :optionsList="tipos_receita"
                      optionsDisplay="search"
                      optionsData="id"
                      :edicao="!habilita_ordem"
                      v-model="edicao.st_tipo_receita"
                      :validate="validate">
                      <template v-slot:buttonposb>
                        <div class="input-group-append">
                          <button class="btn" :class="habilita_ordem ? 'btn-secondary' : ' btn-outline-secondary'" type="button" id="button-addon2" @click="habilita_ordem = !habilita_ordem" title="Habilitar Ordenação.">
                            <i class="fas fa-sort"></i>
                          </button>
                        </div>
                      </template>
                    </az-input>
                  </div>
                </div>

                <div class="row mb-2" v-else-if="name == 'receita' && edicao.fl_prescricao && edicao && !kit">
                    <div class="col col-12">
                        <button class="btn btn-sm" :class="habilita_ordem ? 'btn-secondary' : ' btn-outline-secondary'" type="button" id="button-addon2" @click="habilita_ordem = !habilita_ordem" title="Habilitar Ordenação.">
                            <i class="fas fa-sort"></i>
                        </button>
                    </div>
                </div>

                <template v-if="name == 'receita' && ( edicao.st_olhos || tem_colirios )">
                    <az-input
                        sizing="sm" 
                        type="select"
                        :compact="true"
                        label="Aplicação"
                        required
                        :validate="validate"
                        :optionsList="[
                            { id: 'M', search: 'Monocular' }, 
                            { id: 'B', search: 'Binocular' }, 
                        ]" 
                        optionsData="id"
                        v-model="edicao.st_olhos" />
                </template>

                <div class="alert alert-info d-flex justify-content-between" v-if="habilita_ordem">
                  <div>
                    Utilize o recurso de arrastar e soltar para alterar a ordenação dos registros.
                  </div>
                  <div>
                    <a class="card-link" href="#" @click.prevent="habilita_ordem = false">
                      <i class="fa fa-times" aria-hidden="true"></i>
                    </a>
                  </div>
                </div>

                <draggable v-model="ativos" @start="drag=true" @end="drag=false;" ghost-class="primary" :draggable="!habilita_ordem ? '.nao-ordenar' : '.item-lista'">

                  <div v-for="(item, index) in ativos" :key="index" class="item-lista">
                    <az-input
                      name="search_antes"
                      sizing="sm"
                      :ref="'order_set_search_' + name"
                      :placeholder="index_diluente !== null ? 'Pesquisar medicação para diluição...' : 'Pesquisar...' "
                      icon="fas fa-plus"
                      type="autocomplete"
                      optionsMode="aql"
                      :optionsName="service + '.pep' + ( cirurgia ? '.cirurgia' : '' ) + ( consulta ? '.consulta' : '' ) + ( ( name == 'receita' && edicao.fl_prescricao ) ? '.prescricao' : '' )"
                      :optionsExternal="!block_inclusao_procedimento && !block_inclusao_medicamento"
                      :service="service"
                      :optionsSync="!!receita_medicamento_buscar"
                      :optionsParm="{
                        pep: true,
                        cirurgia: cirurgia,
                        consulta: consulta,
                        prescricao: ( name == 'receita' && edicao.fl_prescricao ) ? true : false,
                        cbhpm: true,
                        id_unidade_operacao: ( atendimento && atendimento.marcacao && atendimento.marcacao.id_unidade_operacao ) ? atendimento.marcacao.id_unidade_operacao : null,
                      }"
                      v-model="novo_item"
                      @selecionado="incluir_item (null, index)"
                      v-if="!habilita_ordem && index_inclusao === index" />
                      
                    <div class="w3-animate-opacity" :class="( item.index_diluente === 0 || item.index_diluente ) ? 'ml-3' : ''">
                      <!-- Itens Selecioandos -->
                      <div class="row">
                        <div class="col" :class="item_formula(item) ? 'col-12 col-md-8' : ''">
                          <template v-if="item.item.incluir || 1 == 1">
                            <az-input
                                sizing="sm"
                                v-model="item.item.search"
                                :edicao="item.item.incluir">
                                <template v-slot:button-pre>
                                    <div class="input-group-prepend" v-if="!habilita_ordem">
                                        <button type="button" class="btn btn-outline-danger" @click="excluirItem(item)">
                                            <i class="fa fa-minus fa-fw" aria-hidden="true"></i>
                                        </button>
                                    </div>
                                </template>
                                <template v-slot:button-pos v-if="!habilita_ordem">
                                    <div class="input-group-append">
                                        <span class="input-group-text" id="basic-addon2" title="Particular" v-if="item.fl_particular">
                                            <i class="fa-solid fa-dollar-sign"></i>
                                        </span>
                                        <span class="input-group-text" id="basic-addon2" title="Id de Medicamento">
                                            <small>#{{ item.id_medicamento ? item.id_medicamento : item.id_procedimento }}</small>
                                        </span>
                                    </div>

                                    <input type="number" placeholder="1" class="form-control" v-if="name== 'requisicao'"
                                    style="max-width: 50px; margin: auto;" v-model="item.in_quantidade">
                                    <div class="input-group-append">
                                    <!-- Botão de Execução Imediata -->
                                    <button type="button" class="btn btn-sm btn-outline-success" v-if="item.fl_execucao_imediata === true || item.fl_execucao_imediata === false"
                                        data-toggle="tooltip" data-placement="top" title="Execução Imediata"
                                        @click="item.fl_execucao_imediata = !item.fl_execucao_imediata">
                                        <i class="fa fa-play" aria-hidden="true" v-if="item.fl_execucao_imediata == false"></i>
                                        <i class="fa fa-pause" aria-hidden="true" v-if="item.fl_execucao_imediata == true"></i>
                                    </button>

                                    <!-- Botão de Edição da Descrição -->
                                    <button type="button" class="btn btn-sm btn-outline-primary"
                                        v-if="item.item && item.item.fl_permite_editar_texto && item.item.st_texto_requisicao"
                                        data-toggle="tooltip" data-placement="top" title="Editar Texto"
                                        @click="item.st_texto_impressao = item.item.st_texto_requisicao; item.fl_texto_editado = !item.fl_texto_editado">
                                        <i class="fas fa-pen"></i>
                                    </button>

                                    <!-- Botão de Lançamento Ordenado -->
                                    <button type="button" class="btn btn-sm btn-outline-success" v-if="name == 'receita'"
                                        data-toggle="tooltip" data-placement="top" title="Incluir antes"
                                        @click="incluir_antes(index)">
                                        <template v-if="index_inclusao == index">
                                        <i class="fa fa-times" aria-hidden="true"></i>
                                        </template>
                                        <template v-else>
                                        <i class="fa fa-plus mr-1" aria-hidden="true"></i>
                                        <i class="fas fa-arrow-up"></i>
                                        </template>
                                    </button>

                                    <!-- Seleção de Unidades para o Item -->
                                    <button type="button" class="btn btn-outline-primary btn-sm"
                                            v-if="item.id_item_kit_medicamento"
                                            data-toggle="tooltip" data-placement="top" title="Unidades Habilitadas"
                                            :disabled="!!id_unidade_operacao"
                                            @click="unidade_operacao_lista(item)">
                                            <i class="fa-regular fa-building"></i>

                                            <span class="badge badge-primary ml-1" title="Unidades Selecionados" v-if="item.unidade_operacao_lista_count">
                                                {{ item.unidade_operacao_lista_count }}
                                            </span>
                                    </button>

                                    <button type="button" class="btn btn-sm btn-outline-primary" v-if="name == 'receita'"
                                        title="Agrupamento" @click="item.st_agrupa === null ? item.st_agrupa = '' : item.st_agrupa = null">
                                        <i class="fa-solid fa-expand"></i>
                                    </button>
                                    <button
                                        class="btn btn-sm btn-outline-primary"
                                        type="button"
                                        data-toggle="tooltip" data-placement="top" title="Observações"
                                        @click="item.st_observacoes = ( item.st_observacoes !== null ? null : '' )">
                                        <i class="fas fa-comment"></i>
                                    </button>
                                    <button
                                        class="btn btn-sm btn-outline-secondary dropdown-toggle"
                                        type="button"
                                        title="Agrupamento na impressão"
                                        data-toggle="dropdown"
                                        aria-haspopup="true"
                                        aria-expanded="false"
                                        v-if="!item_formula(item) || item.fl_imprimir_separado"
                                    >
                                        <span v-if="!item.fl_imprimir_separado && item.item && item.item.grupo && item.item.grupo.st_sigla">
                                        {{ item.item.grupo.st_sigla }}
                                        </span>
                                        <i class="fas fa-copy fa-fw mr-2" v-else-if="item.fl_imprimir_separado"></i>
                                        <i class="fas fa-file fa-fw mr-2" v-else></i>
                                    </button>
                                    <div class="dropdown-menu">
                                        <a class="dropdown-item" href="#" @click.prevent="item.fl_imprimir_separado = false">
                                        <i class="fas fa-file mr-2"></i>Imprimir Junto
                                        </a>
                                        <a class="dropdown-item" href="#" @click.prevent="item.fl_imprimir_separado = true">
                                        <i class="fas fa-copy mr-2"></i>Imprimir Separado
                                        </a>
                                        <template v-if="procGrupos && procGrupos.length">
                                        <div class="dropdown-divider"></div>
                                        <a class="dropdown-item" href="#" @click.prevent="selecionar_grupo(item, grupo)"
                                            v-for="(grupo, igx) in procGrupos" :key="igx">
                                            {{ grupo.st_sigla }}
                                        </a>
                                        </template>
                                        <template v-if="item && item.item && !item.item.incluir">
                                        <div class="dropdown-divider"></div>
                                        <a class="dropdown-item" href="#" @click.prevent="incluir_proc(item)">
                                            <i class="fa fa-plus mr-2" aria-hidden="true"></i>Editar e Incluir
                                        </a>
                                        </template>
                                    </div>
                                    </div>
                                </template>
                            </az-input>

                            <az-input
                              type="textarea"
                              rows="3"
                              v-if="item.fl_texto_editado"
                              v-model="item.st_texto_impressao" />

                          </template>

                          <template v-else>
                            <az-input
                              sizing="sm"
                              icon="fas fa-plus"
                              type="autocomplete"
                              optionsMode="aql"
                              :service="service"
                              :optionsSync="false"
                              v-model="item.item"
                              buttonText="fas fa-minus"
                              :buttonIcon="true"
                              buttonColor="outline-danger"
                              :iconEnd="name == 'requisicao' ? { color: 'outline-primary', icon: 'fas fa-comment' } : null"
                              @clickButtonEnd="item.st_observacoes = ( item.st_observacoes !== null ? null : '' )"
                              @clickButton="excluirItem(item)"
                            />
                          </template>
                        </div>
                        <div class="col col-12 col-md-2" v-if="item_formula(item)">
                          <az-input
                            sizing="sm"
                            placeholder="Qtd..."
                            type="number"
                            v-model="item.in_quantidade"
                          />
                        </div>
                        <div class="col col-12 col-md-2" v-if="item_formula(item)">
                          <az-input
                            sizing="sm"
                            type="select"
                            optionsMode="aql"
                            service="apresentacoes.index"
                            v-model="item.apresentacao"
                          />
                        </div>
                      </div>

                      <!-- Complementos de Receita -->

                      <div class="form-row" :class="( item.st_observacoes !== null || item.st_agrupa !== null ) ? 'mb-0' : 'mb-2'"
                        v-if="name == 'receita' && !item_formula(item) && !habilita_ordem">
                        <div class="col col-12 col-md-2">
                          <az-input
                            sizing="sm"
                            placeholder="Qtd..."
                            type="number"
                            v-model="item.in_quantidade" />

                          <div class="input-group input-group-sm mb-0" v-if="item && item.item && item.item.fl_diluente">
                            <input type="text" class="form-control" placeholder="Diluente" disabled>
                            <div class="input-group-append">
                              <button class="btn btn-outline-secondary" type="button" id="button-addon2" title="Adicionar medicamento diluído." @click="incluir_antes(index + 1, index)">
                                <i class="fa fa-times" aria-hidden="true" v-if="index_diluente !== null && index_diluente === index"></i>
                                <i class="fa fa-plus" aria-hidden="true" v-else></i>
                              </button>
                            </div>
                          </div>

                          <div v-else-if="item.index_diluente === 0 || item.index_diluente" class="small text-muted">
                            Diluído
                          </div>
                        </div>

                        <div class="col col-12 col-md-3">
                          <!-- icon="fas fa-plus" -->

                          <az-input
                            sizing="sm"
                            type="select"
                            optionsMode="aql"
                            service="apresentacoes.index"
                            v-model="item.apresentacao" />

                          <div v-if="item.apresentacao && ( item.dc_dose_calc || item.fl_calc_edit )">
                            <az-input
                                type="number"
                                sizing="sm"
                                placeholder="Dose..."
                                :edicao="!!item.fl_calc_edit"
                                v-model="item.dc_dose_calc">
                                <template v-slot:button-pre>
                                    <div class="input-group-prepend">
                                        <button type="button" class="btn btn-outline-primary" v-if="!item.fl_calc_edit" @click="item.fl_calc_edit = true"><i class="fa-solid fa-pen-to-square"></i></button>
                                        <button type="button" class="btn btn-outline-secondary" v-else @click="item.fl_calc_edit = false"><i class="fa-solid fa-xmark"></i></button>
                                    </div>
                                </template>
                                <template v-slot:buttonposb>
                                    <div class="input-group-append">
                                        <span class="input-group-text" id="basic-addon1">{{ item.apresentacao.st_unid_calc }}</span>
                                    </div>
                                </template>
                            </az-input>
                          </div>

                          <div v-if="edicao.fl_ciclos && edicao.st_tipo != 'U' && edicao.st_tipo_receita != 'U'" class="small text-muted">
                            <az-input
                              sizing="sm"
                              placeholder="Não informado..."
                              :validate="validate"
                              v-model="item.st_ciclo_dias">
                              <template v-slot:button-pre>
                                <div class="input-group-prepend">
                                  <span class="input-group-text" id="basic-addon1">Dias</span>
                                </div>
                              </template>
                            </az-input>
                          </div>
                        </div>

                        <div class="col col-12 col-md-7">
                            <az-input
                                type="textarea"
                                :rows="( edicao.fl_ciclos && !( value && value.fl_prescricao && ( vias.length || usos.length ) ) ) ? 3 : 2"
                                sizing="sm"
                                placeholder="Posologia..."
                                maxlength="1000"
                                v-model="item.st_posologia"
                                :edicao="!edicao.kit || !edicao.kit.fl_block_posologia"
                            />

                            <div class="mb-2" v-if="!item.id_receita_medicamento && item.item && item.item.tem_posologias && item.item.js_posologias && item.item.js_posologias.length">
                                <div class="small text-muted d-flex justify-content-between">
                                    <div>Opções</div>
                                    <div>
                                        <a href="#" @click.prevent="item.item.tem_posologias = false">
                                            <i class="fa fa-times text-danger" aria-hidden="true"></i>
                                        </a>
                                    </div>
                                </div>
                                <div class="list-group">
                                    <button type="button" class="list-group-item list-group-item-action p-2 small" @click="item.st_posologia = posologia.texto" v-for="(posologia, ipx) in item.item.js_posologias" :key="ipx">
                                        {{ posologia.texto }}
                                    </button>
                                </div>
                            </div>

                            <div class="form-row" v-if="value 
                                                        && ( value.fl_prescricao || kit ) 
                                                        && ( vias.length || usos.length ) 
                                                        && ( item.id_prescricao_via 
                                                            || item.id_prescricao_uso 
                                                            || ( item.item && item.item.fl_info_via_uso ) )">
                                <div class="col col-12 col-md-6">
                                    <az-input
                                        sizing="sm"
                                        type="select"
                                        :compact="true"
                                        label="Via"
                                        optionsMode="json"
                                        :optionsList="vias"
                                        optionsDisplay="search"
                                        optionsData="id_prescricao_via"
                                        placeholder="Via..."
                                        v-model="item.id_prescricao_via" />
                                </div>
                                <div class="col col-12 col-md-6">
                                    <az-input
                                        sizing="sm"
                                        type="select"
                                        :compact="true"
                                        label="Uso"
                                        optionsMode="json"
                                        :optionsList="usos"
                                        optionsDisplay="search"
                                        optionsData="id_prescricao_uso"
                                        placeholder="Uso..."
                                        v-model="item.id_prescricao_uso" />
                                </div>
                            </div>

                            <div class="form-row" 
                                v-if="value 
                                    && ( value.fl_prescricao || kit )
                                    && ( item.id_med_dil 
                                        || (  
                                                item.item 
                                                && !item.item.fl_diluente
                                                && item.item.fl_info_dil
                                        ) 
                                    )">
                                <div class="col col-12">
                                    <az-input
                                        sizing="sm"
                                        type="select"
                                        :compact="true"
                                        label="Diluente"
                                        optionsMode="aql"
                                        service="medicamentos.index"
                                        optionsDisplay="search"
                                        optionsData="id_medicamento"
                                        :optionsParm="{ diluente: 1, pep: 1 }"
                                        placeholder="Nenhum..."
                                        v-model="item.id_med_dil">
                                        <template v-slot:buttonposb>
                                            <div class="input-group-append" v-if="item.id_med_dil">
                                                <span class="input-group-text">#{{ item.id_med_dil }}</span>
                                            </div>
                                        </template>
                                    </az-input>
                                </div>
                            </div>

                        </div>
                      </div>

                      <div class="row" v-if="value.fl_cirurgia">
                        <div class="col">
                          <az-input
                            sizing="sm"
                            placeholder="Código da Cirurgia..."
                            :required="cod_cirurg_obrig"
                            :validate="validate"
                            v-model="item.st_codigo"
                          />
                        </div>
                      </div>

                      <!-- Complementos de Requisição -->

                      <template v-if="item.item && item.item.js_complementos && item.item.js_complementos.length && !item.st_observacoes && !item.id_requisicao_procedimento">
                        <table class="table table-sm border-0 table-responsive mb-1">
                            <tr>
                                <td class="text-nowrap py-0">
                                    <a href="#" @click.prevent="item.st_observacoes = classe" v-for="(classe, icx) in item.item.js_complementos" :key="icx">
                                        <span class="badge badge-secondary mr-1" >
                                            {{ classe }}
                                        </span>
                                    </a>
                                </td>
                            </tr>
                        </table>
                      </template>

                      <div class="row" v-if="item.st_observacoes !== null " :class=" ( name == 'receita' && item.st_agrupa !== null ) ? '' : 'mb-2'">
                        <div class="col">
                          <az-input
                            icon="fas fa-comment fa-fw"
                            sizing="sm"
                            placeholder="Observações..."
                            type="textarea"
                            :rows="calc_rows(item.st_observacoes)"
                            maxlength="1000"
                            v-model="item.st_observacoes" />
                        </div>
                      </div>

                      <!-- Complementos de Requisição -->
                      <div class="mb-3" v-if="item.item && item.item.id_classe_procedimento == 20 && item.item.js_complementos && item.item.js_complementos.length">

                        <div v-if="imuno_paineis && imuno_paineis.length" class="mb-1">
                            <button type="button" class="btn btn-sm btn-outline-primary" v-for="(painel, index) in imuno_paineis" :key="index" @click="selecionar_painel(item, painel)">
                                {{ painel.search }}
                            </button>
                        </div>

                        <multiselect
                            v-model="item.js_classes"
                            :options="item.item.js_complementos"
                            :multiple="true"
                            :taggable="false"
                            tag2="addTagComp(item, $event)"
                            placeholder="Selecione os Anticorpos..."
                            selectLabel="Pressione [ENTER] para selecionar"
                            deselectLabel="Pressione [ENTER] para remover"
                            tagPlaceholder="Pressione [ENTER] para incluir"
                            selectedLabel="Selecionado">
                            <template slot="noOptions">
                                Nenhum item selecionado.
                            </template>
                            <template slot="noResult">
                                Item não identificado.
                            </template>
                        </multiselect>

                         <!-- Seleção do Cassete -->
                        <template v-if="cassetes && cassetes.length && item.js_classes && item.js_classes.length">

                            <div v-if="cassetes && cassetes.length && item.js_classes && item.js_classes.length" class="form-row mt-3">
                                <div class="col col-12 col-md-4">
                                    <div class="list-group">
                                        <button type="button" class="list-group-item list-group-item-action py-2 small" v-for="(cassete, icx) in cassetes" :key="icx" @click="incluir_cassete(item, cassete)">
                                            {{ cassete.st_titulo }}
                                            <span class="text-muted ml-2">{{ cassete.st_codigo }}</span>
                                        </button>
                                    </div>
                                </div>

                                <div class="col col-12 col-md-8">
                                    <table class="table table-sm table-hover small">
                                        <thead>
                                            <tr>
                                                <th>Selecionado</th>
                                                <th>Anticorpos</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <template v-for="(rpq, iqx) in item.cassetes">
                                                <tr v-if="!rpq.excluido" :key="iqx">
                                                    <td width="50%" class="text-nowrap">
                                                        <a href="#" @click.prevent="rpq.excluido = true" class="card-link mr-2">
                                                            <i class="fa fa-times text-danger" aria-hidden="true"></i>
                                                        </a>
                                                        {{ rpq.amostra.st_titulo }}
                                                    </td>
                                                    <td width="50%">
                                                        <span class="badge badge-light mr-1" v-for="(classe, icx) in rpq.js_classes" :key="icx">
                                                            <a href="#" @click.prevent="remover_item_lista(rpq.js_classes, icx)" class="card-link mr-1">
                                                                <i class="fa fa-times text-danger" aria-hidden="true"></i>
                                                            </a>
                                                            {{ classe }}
                                                        </span>
                                                    </td>
                                                </tr>
                                            </template>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </template>
                      </div>

                      <!-- Agrupamento -->

                      <div class="form-row mb-2" v-if="name == 'receita' && item.st_agrupa !== null">
                        <div class="col col-12">
                          <az-input
                            icon="fa-solid fa-expand fa-fw"
                            sizing="sm"
                            placeholder="Agrupamento..."
                            v-model="item.st_agrupa" />
                        </div>
                      </div>

                    </div>

                    <div v-if="item.diluidos && listar_ativos(item.diluidos).length">
                      <div class="card">
                        <div class="card-header alert-info py-1 d-flex justify-content-between">
                          <a class="card-link small" data-toggle="collapse" :href="'#dil' + index" role="button" aria-expanded="false" aria-controls="collapseExample">
                            Diluídos no {{ item.item.search }}
                          </a>
                          <span class="badge badge-info">
                            {{ listar_ativos(item.diluidos).length }}
                          </span>
                        </div>
                        <div class="card-body pt-3 pb-0 collapse show" :id="'dil' + index" >
                          <div v-for="(diluido, idx) in listar_ativos(item.diluidos)" :key="idx">
                            <order-set-item
                              :value="diluido"
                              :edicao="edicao"
                              :habilita_ordem="habilita_ordem"
                              :name="name"
                              :inclusao="index_inclusao == index"
                              :procGrupos="procGrupos"
                              :cod_cirurg_obrig="cod_cirurg_obrig"
                              :validate="validate" />
                          </div>
                        </div>
                      </div>
                    </div>

                    <pre v-if="false">{{ item }}</pre>
                  </div>

                </draggable>

                <!-- Fim da Lista -->

                <template v-if="!habilita_ordem">

                  <az-input
                    sizing="sm"
                    :ref="'order_set_search_' + name"
                    :placeholder="index_diluente !== null ? 'Pesquisar medicação para diluição...' : 'Pesquisar...' "
                    icon="fas fa-plus"
                    type="autocomplete"
                    optionsMode="aql"
                    :optionsName="service + '.pep' + ( cirurgia ? '.cirurgia' : '' ) + ( consulta ? '.consulta' : '' )
                      + ( ( config_local_exec == 'I' && atendimento && atendimento.plano ) ? '.' + atendimento.plano.id_plano : '' )
                      + ( ( name == 'receita' && edicao.fl_prescricao ) ? '.prescricao' : '' )"
                    :optionsExternal="!block_inclusao_procedimento && !block_inclusao_medicamento && config_local_exec != 'I'"
                    :service="service"
                    :optionsSync="!!receita_medicamento_buscar"
                    :optionsParm="{
                      pep: true,
                      agenda: config_local_exec == 'I',
                      combos: config_local_exec == 'I',
                      cirurgia: cirurgia,
                      consulta: consulta,
                      prescricao: ( name == 'receita' && edicao.fl_prescricao ) ? true : false,
                      cbhpm: true,
                      id_unidade_operacao: ( atendimento && atendimento.marcacao && atendimento.marcacao.id_unidade_operacao ) ? atendimento.marcacao.id_unidade_operacao : null,
                      id_operadora: ( atendimento && atendimento.plano && config_local_exec == 'I' ) ? atendimento.plano.id_operadora : null,
                      id_plano: ( atendimento && atendimento.plano && config_local_exec == 'I' ) ? atendimento.plano.id_plano : null,
                    }"
                    v-model="novo_item"
                    v-if="!trocando_local_exec && ( index_inclusao === null || ( index_inclusao >= ativos.length && index_diluente !== null ) )"
                    @selecionado="incluir_item ()">
                    <template v-slot:buttonposb>
                      <div class="input-group-append" v-if="name == 'requisicao' && !cirurgia && !consulta">
                        <button class="btn btn-outline-secondary dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                          <i class="fa-solid fa-right-to-bracket fa-fw" v-if="config_local_exec == 'I'"></i>
                          <i class="fa-solid fa-right-from-bracket fa-fw" v-else></i>
                        </button>
                        <div class="dropdown-menu">
                          <a class="dropdown-item" href="#" @click.prevent="set_local_exec('I')">
                            <i class="fa-solid fa-right-to-bracket fa-fw mr-2"></i>
                            Realizar internamente
                          </a>
                          <a class="dropdown-item" href="#" @click.prevent="set_local_exec('E')">
                            <i class="fa-solid fa-right-from-bracket fa-fw mr-2"></i>
                            Realizar em outra unidade
                          </a>
                        </div>
                      </div>
                    </template>
                  </az-input>

                  <div class="input-group input-group-sm" v-if="id_paciente && edicao.fl_exibir_data !== null">
                    <div class="input-group-prepend">
                      <div class="input-group-text">
                        <input
                          class="fa-fw"
                          type="checkbox"
                          aria-label="Checkbox for following text input"
                          v-model="edicao.fl_exibir_data"
                        />
                      </div>
                    </div>
                    <input
                      type="date"
                      class="form-control"
                      placeholder="Nome do Kit..."
                      v-if="edicao.fl_exibir_data"
                      v-model="edicao.dt_referencia"
                    />
                    <label class="form-control" v-else>Sem data</label>
                  </div>

                  <div class="small mt-3" v-if="false && name == 'receita'">
                    <a href="http://www.anvisa.gov.br/datavisa/fila_bula/index.asp" class="card-link" target="_blank">
                      Bulário Eletrônico ANVISA
                    </a>
                  </div>

                  <!-- Observações -->

                  <div class="mt-3" v-if="name == 'requisicao' || name == 'receita'">

                    <div>
                      <az-input
                        sizing="sm"
                        :label="edicao.st_observacoes ?  'Observações' : ''"
                        placeholder="Observações..."
                        type="textarea"
                        :rows="calc_rows(edicao.st_observacoes)"
                        maxlength="1000"
                        v-model="edicao.st_observacoes" />
                    </div>

                    <div>
                      <az-input
                        sizing="sm"
                        :label="edicao.st_observacoes_interno  ?  'Observações Internas' : ''"
                        placeholder="Observações Internas... (Não Impressa)"
                        type="textarea"
                        :rows="calc_rows(edicao.st_observacoes_interno)"
                        maxlength="1000"
                        v-model="edicao.st_observacoes_interno" />
                    </div>

                  </div>

                  <!-- Classificação -->

                  <div class="mt-3" v-if="kit">
                    <div class="row mt-3">
                      <div class="col col-12">
                        <small class="text-muted">Classificação</small>
                        <multiselect
                            v-model="edicao.js_classes"
                            :options="options_classes"
                            :multiple="true"
                            :taggable="true"
                            @tag="addTag"
                            placeholder="Selecione uma classificação..."
                            selectLabel="Pressione [ENTER] para selecionar"
                            deselectLabel="Pressione [ENTER] para remover"
                            tagPlaceholder="Pressione [ENTER] para incluir"
                            selectedLabel="Selecionado">
                            <template slot="noOptions">
                                Nenhuma classificação criada.
                            </template>
                        </multiselect>
                      </div>
                    </div>

                    <div class="form-row mt-2" v-if="edicao.fl_ciclos">
                        <div class="col col-12 col-md-6">
                            <az-input
                                type="checkbox-group"
                                sizing="sm"
                                label="Bloquear reordenação dos itens"
                                v-model="edicao.fl_block_reordem" />
                        </div>

                        <div class="col col-12 col-md-6">
                            <az-input
                                type="checkbox-group"
                                sizing="sm"
                                label="Bloquear edição da posologia"
                                v-model="edicao.fl_block_posologia" />
                        </div>
                    </div>
                  </div>

                  <!-- Fim Observações -->

                  <div class="list-group mt-4 mb-3">
                    <button
                      type="button"
                      class="list-group-item list-group-item-action list-group-item-secondary btn-sm"
                      @click="incluir_item({ item: mu, apresentacao: mu.apresentacao, st_posologia: mu.st_posologia })"
                      v-for="(mu, imu) in lista_usados"
                      :key="imu"
                    >{{ mu.search }}</button>
                  </div>

                  <div v-if="consulta && lista_medicos && Object.keys(lista_medicos).length">
                    <div class="card" v-for="(medicos, proc, ipx) in lista_medicos" :key="ipx">
                      <div class="card-header p-2">
                        <small>{{ proc }}</small>
                      </div>
                      <ul class="list-group">
                        <li class="list-group-item d-flex justify-content-between" v-for="(medico, imx) in medicos" :key="imx">
                          <div>
                            <a href="#" @click="selecionar_medico_consulta(proc, medico)" class="card-link">
                              {{ medico.search }}
                            </a>
                            <div class="small" v-if="medico.hor_atend && medico.hor_atend.texto">
                              hoje: {{ medico.hor_atend.texto }}
                            </div>
                            <div class="small text-muted" style="white-space: pre" v-if="medico.medico_unidade && medico.medico_unidade.st_instrucao">{{ medico.medico_unidade.st_instrucao }}</div>
                          </div>
                          <div v-if="medico && medico.logo && medico.logo.arquivo">
                            <avatar
                              :username="medico.st_nome_exibicao"
                              :src="medico.logo.arquivo.public_url"
                              :size="80">
                            </avatar>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>

                  <template v-if="cirurgia">
                    <template v-if="!kit">
                      <az-input
                          v-if="!edicao.st_hospital"
                          label="Hospital"
                          sizing="sm"
                          optionsMode="aql"
                          service="centro_cirurgicos.index"
                          :validate="validate"
                          ref="order_set_hopital"
                          placeholder="Pesquisar..."
                          type="autocomplete"
                          optionsData="id_centro_cirurgico"
                          :optionsExternal="true"
                          :optionsSync="true"
                          v-model="novo_hospital"
                          @selecionado="incluir_hospital ()"
                      />

                      <az-input v-else
                          label="Hospital"
                          sizing="sm"
                          v-model="edicao.st_hospital"
                      />
                    </template>

                    <div class="row">

                        <div class="col col-12 col-md-4" v-if="!kit">
                            <az-input
                                label="Data sugerida da internação"
                                type="date"
                                sizing="sm"
                                placeholder="Selecione a data..."
                                v-model="edicao.dt_sugerida_internacao"
                            />
                        </div>

                        <div class="col col-12 col-md-4">
                            <az-input
                                label="Regime de internação"
                                type="select"
                                optionsMode="json"
                                :optionsList="[
                                    { id: '1', search: 'Hospitalar' },
                                    { id: '2', search: 'Hospital-Dia' },
                                    { id: '3', search: 'Domiciliar' },
                                ]"
                                optionsDisplay="search"
                                optionsData="id"
                                sizing="sm"
                                placeholder="Selecione o Regime de internação"
                                v-model="edicao.in_regime_internacao"
                            />
                        </div>

                        <div class="col col-12 col-md-4">
                            <az-input
                                label="Qtde. diárias"
                                type="number"
                                sizing="sm"
                                placeholder="Informe a Qtde. de diárias"
                                v-model="edicao.in_diarias"
                            />
                        </div>

                    </div>

                    <az-input
                        label="Indicação clínica"
                        type="textarea"
                        sizing="sm"
                        :validate="validate"
                        rows="2"
                        v-model="edicao.st_indicacao_clinica" />

                    <az-input
                        label="Carater atendimento"
                        sizing="sm"
                        type="select"
                        :optionsList="[
                            { id: 'E', search: 'Eletivo' },
                            { id: 'U', search: 'Urgência' },
                        ]"
                        optionsData="id"
                        :validate="validate"
                        rows="2"
                        v-model="edicao.st_carater_atendimento" />

                    <az-input
                      v-if="!kit"
                      sizing="sm"
                      type="checkbox-group"
                      label="Médico solicitante como contratado"
                      :validate="validate"
                      v-model="edicao.fl_medico_como_contratado" />

                    <template v-if="edicao.materiais">
                      <az-sub-title title="OPMEs"></az-sub-title>
                      <template v-for="(opme, iox) in edicao.materiais">
                        <div  :key="'opme' + iox" v-show="opme.fl_ativo" v-if="true">
                          <div class="form-row">
                            <div v-if="opme.id_material" class="col col-12 col-md-6">
                              <az-input
                                  sizing="sm"
                                  :edicao="false"
                                  v-if="opme.material"
                                  v-model="opme.material.search">
                                <template v-slot:button-pre>
                                  <div class="input-group-prepend">
                                    <button class="btn btn-outline-danger" type="button" id="button-addon2" @click="opme.fl_ativo = false">
                                      <i class="fa fa-minus fa-fw" aria-hidden="true"></i>
                                    </button>
                                  </div>
                                </template>
                              </az-input>
                            </div>
                            <div v-else-if="opme.id_medicamento" class="col col-12 col-md-6">
                              <az-input
                                  v-if="opme.medicamento"
                                  sizing="sm"
                                  :edicao="false"
                                  v-model="opme.medicamento.search">
                                <template v-slot:button-pre>
                                  <div class="input-group-prepend">
                                    <button class="btn btn-outline-danger" type="button" id="button-addon2" @click="opme.fl_ativo = false">
                                      <i class="fa fa-minus fa-fw" aria-hidden="true"></i>
                                    </button>
                                  </div>
                                </template>
                              </az-input>
                            </div>
                            <template v-else>
                              <div class="col col-12 col-md-4">
                                <az-input
                                    sizing="sm"
                                    :edicao="false"
                                    v-model="opme.st_descricao">
                                  <template v-slot:button-pre>
                                    <div class="input-group-prepend">
                                      <button class="btn btn-outline-danger" type="button" id="button-addon2" @click="opme.fl_ativo = false">
                                        <i class="fa fa-minus fa-fw" aria-hidden="true"></i>
                                      </button>
                                    </div>
                                  </template>
                                </az-input>
                              </div>

                              <div class="col col-12 col-md-2">
                                <az-input
                                    sizing="sm"
                                    placeholder="Código..."
                                    v-model="opme.st_codigo" />
                              </div>
                            </template>
                            <div class="col col-12 col-md-2">
                              <az-input
                                  sizing="sm"
                                  type="number"
                                  v-model="opme.in_quantidade" />
                            </div>
                            <div class="col col-12 col-md-4">
                              <az-input
                                  sizing="sm"
                                  placeholder="Fabricante..."
                                  v-model="opme.st_fabricante" />
                            </div>
                          </div>
                        </div>
                      </template>
                      <pre v-if="false">{{ edicao.materiais }}</pre>
                      <!-- 
                      <az-input
                        class="mb-3"
                        sizing="sm"
                        icon="fas fa-cart-plus fa-fw"
                        buttonToolTip="Incluir OPME..."
                        type="autocomplete"
                        optionsMode="aql"
                        optionsName="materiais.index"
                        :optionsExternal="true"
                        service="materiais.index"
                        optionsParm2="{ id_operadora: dados.plano.operadora.id_operadora }"
                        :optionsSync="true"
                        placeholder="Incluir OPME..."
                        v-model="novoOpme"
                        @input="incluirOpme()"  />
                    -->

                    <az-input
                        class="mb-3"
                        sizing="sm"
                        icon="fas fa-cart-plus fa-fw"
                        buttonToolTip="Incluir OPME..."
                        type="autocomplete"
                        optionsMode="aql"
                        optionsName="consumo.index"
                        :optionsExternal="true"
                        service="consumo.index"
                        :optionsParm="{ bt: true }"
                        optionsParm2="{ id_operadora: dados.plano.operadora.id_operadora }"
                        :optionsSync="true"
                        placeholder="Incluir OPME..."
                        v-model="novoOpme"
                        @input="incluirOpme()"  />
                    </template>
                  </template>

                  <template v-else-if="this.name == 'requisicao' && !kit">
                    <az-input
                        label="Indicação clínica"
                        type="textarea"
                        sizing="sm"
                        :validate="validate"
                        rows="2"
                        v-model="edicao.st_indicacao_clinica" />

                    <az-input
                        label="Carater atendimento"
                        sizing="sm"
                        type="select"
                        :optionsList="[
                            { id: 'E', search: 'Eletivo' },
                            { id: 'U', search: 'Urgência' },
                        ]"
                        optionsData="id"
                        :validate="validate"
                        rows="2"
                        v-model="edicao.st_carater_atendimento" />
                  </template>

                  <template v-if="assistprocs && assistprocs.length > 1">
                    <div class="small text-primary">Procedimentos</div>
                    <div class="list-group">
                      <button type="button" class="list-group-item list-group-item-action"
                        :class="( proc.dados.anamnese && proc.dados.anamnese.id_anamnese == edicao.id_anamnese )
                          ? 'active disabled'
                          : ( $store.state.loading ? 'disabled' : '' ) "
                        v-for="(proc, ipx) in assistprocs" :key="ipx" @click="atualizar(false, false, proc)">
                        {{ proc.proc.search }}
                      </button>
                    </div>
                  </template>

                </template>

                <div class="my-5">&nbsp;</div>

                <div class="my-5">&nbsp;</div>

                <template v-if="1 == 0">
                  <pre class="alert alert-warning">{{ edicao }}</pre>
                </template>
              </div>

              <div class="col col-12 col-md-4" v-if="id_paciente">
                <!-- Históricos -->

                <az-input
                  sizing="sm"
                  type="button-group"
                  v-model="viewMode"
                  :optionsList="[{ id: 'kit', search: 'Kits'},{ id: 'historico', search: 'Histórico' },{ id: 'notas', search: 'Notas' }]"
                />

                <az-input
                    icon="fa fa-search"
                    sizing="sm"
                    placeholder="Pesquisar..."
                    :edicao="viewMode != 'notas'"
                    v-model="search_kit">
                    <template v-slot:buttonposb>
                        <div class="input-group-append">
                            <button class="btn" :class="apenas_favoritos ? 'btn-outline-warning' : 'btn-outline-secondary'" type="button" id="button-addon2" @click="apenas_favoritos = !apenas_favoritos" title="Favoritos">
                                <i class="fa-solid fa-star fa-fw"></i>
                            </button>
                        </div>
                    </template>
                </az-input>


                <div class="card overflow-auto" style="padding: 0px; height: 64vh;">

                  <template v-if="viewMode == 'notas'">
                    <div v-if="atendimento" class="p-2">
                      <div v-for="(atp, iax) in atendimento.atendimento_procedimentos" :key="iax">
                        <formulario
                          :onecol="true"
                          v-model="atp.anamnese.dados"
                          mode="view"
                          :view_with_print="false"
                          tamanho="P"
                          @imprimirAnamnese="imprimirAnamnese(atdp.anamnese.id_anamnese)"
                          v-if="atp.anamnese" />
                      </div>
                    </div>
                  </template>

                  <template v-else>

                    <div class="card-header p-0" v-if="viewMode == 'kit' && lista_classes.length">
                      <table class="table table-sm mb-0 pb-2 table-responsive" v-if="viewMode == 'kit' && lista_classes.length">
                          <tr>
                              <td class="text-nowrap">
                                  <a href="#" @click.prevent="filtrar(classe)" v-for="(classe, icx) in lista_classes" :key="icx">
                                      <span class="badge badge-success mr-1" >
                                          {{ classe }}
                                      </span>
                                  </a>
                              </td>
                          </tr>
                      </table>
                    </div>

                    <template v-for="(hist, ih) in lista_ajuda">
                      <div class="card-header px-2" :key="'hr' + ih" v-if="true">
                        <div class="d-flex justify-content-between">
                          <small>
                            <a href="#" @click.prevent title="Favoritar" @click="favoritar(hist)">
                                <i class="fa-regular fa-star fa-fw text-muted mr-2" v-if="!hist.favorito"></i>
                                <i class="fa-solid fa-star fa-fw mr-2 text-warning" v-else></i>
                            </a>

                            <a class="card-link" data-toggle="collapse" :href="'#hr' + ih">
                              {{ hist.st_nome }}
                              <span class="badge badge-secondary">
                                {{ historico_flat(hist).length }}
                              </span>
                            </a>
                          </small>
                          <span class="collapse" :id="'hr' + ih">
                            <a href="#" class="card-link small" @click.prevent="incluir_items (hist)">
                              COPIAR
                            </a>
                            <a href="#" class="card-link ml-2" @click.prevent="toggle_sort(hist)" title="Ordem" v-if="!hist.fl_block_reordem">
                              <i class="fas fa-sort-alpha-down fa-fw" v-if="hist.alpha_sorted"></i>
                              <i class="fas fa-sort-amount-down-alt fa-fw" v-else></i>
                            </a>
                          </span>
                        </div>


                        <div class="row" v-if="viewMode == 'historico'">
                          <div class="col col-12 text-truncate">
                            <span class="small mr-2" v-if="hist.subtitulo">{{ hist.subtitulo }}</span>
                            <span class="small text-muted">
                              {{ historico_flat(hist).map(item => item.item.search).join(', ') }}
                            </span>
                          </div>

                          <div v-if="hist.marcacao && hist.marcacao.infusao" class="col col-12 d-flex justify-content-between small text-muted">
                            <div>{{ hist.marcacao.infusao.st_titulo }}</div>
                            <div v-if="hist.marcacao.in_qt_ciclo">C{{ hist.marcacao.in_qt_ciclo }} / D{{ hist.marcacao.in_qt_dia }}</div>
                          </div>
                        </div>
                      </div>
                      <div class="card-body collapse" :id="'hr' + ih" :key="'hrb' + ih" v-if="true">

                        <div v-if="false && hist.marcacao && hist.marcacao.infusao" class="d-flex justify-content-between small text-muted mb-2">
                            <div>{{ hist.marcacao.infusao.st_titulo }}</div>
                            <div v-if="hist.marcacao.in_qt_ciclo">C{{ hist.marcacao.in_qt_ciclo }} / D{{ hist.marcacao.in_qt_dia }}</div>
                        </div>

                        <div v-for="(hmedic, hmi) in historico_flat(hist)" :key="'hmi' + hmi"
                          class="border-bottom">
                          <small>
                            <a
                              href="#"
                              class="card-link mr-1"
                              @click.prevent="incluir_item (hmedic)"
                            >{{ hmedic.item.search }}</a>
                          </small>
                          <small class="text-muted" v-html="hmedic.complemento"></small>

                          <div v-if="hmedic.diluidos && hmedic.diluidos.length">
                            <div v-for="(diluido, idx) in hmedic.diluidos" :key="idx" class="small">
                                <i class="fa fa-plus-circle mr-2" aria-hidden="true"></i>
                                {{ diluido.item.search }}
                                <span v-if="diluido.in_quantidade">
                                    <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                                    <span class="text-muted">{{ diluido.in_quantidade }}{{ diluido.apresentacao ? ' ' + diluido.apresentacao.search : 'x' }}</span>
                                    <span v-if="diluido.qtd_calc && 1==0">
                                        <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                                        <strong class="text-muted">{{ diluido.qtd_calc }}</strong>
                                    </span>
                                </span>

                                <span v-if="diluido.st_ciclo_dias && 1==0">
                                    <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                                    <span class="text-muted">{{ diluido.st_ciclo_dias }}</span>
                                </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </template>
                    <template v-if="lista_ajuda && !lista_ajuda.length">
                      <div class="card-body">Nenhum {{ viewMode }} disponível.</div>
                    </template>
                    <template v-else-if="!lista_ajuda">
                      <div class="card-body">
                        <div class="spinner-border spinner-border-sm" role="status">
                          <span class="sr-only">Loading...</span>
                        </div>
                      </div>
                    </template>
                  </template>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer d-flex justify-content-between flex-column flex-md-row" v-if="edicao">
            <template v-if="kit">
              <div></div>
              <div v-if="kit">
                <az-audit-log-button
                  :model="name == 'receita' ? 'kitMedicamento' : 'kitProcedimento'"
                  :id="name == 'receita' ? edicao.id_kit_medicamento : edicao.id_kit_procedimento"
                  v-if="edicao.id_kit_medicamento || edicao.id_kit_procedimento"
                />
                <button type="button" class="btn btn-secondary mx-2" data-dismiss="modal">Fechar</button>
                <az-submit
                  @click="atualizar ()"
                >{{ ( edicao.id_kit_medicamento || edicao.id_kit_procedimento ? 'Atualizar' : 'Incluir' ) }}</az-submit>
              </div>
            </template>
            <template v-else>
                <div class="d-flex flex-column flex-md-row mb-2 mb-md-0">
                    <div class="form-group mb-0 mr-2" v-if="!block_print">
                        <az-input 
                            id="page-size"
                            type="select"
                            sizing="sm"
                            :optionsList="[
                                { id: 'A4', search: 'A4' },
                                { id: 'A4-T', search: 'A4 (Timbrado)' },
                                { id: 'A4-NT', search: 'A4 (Não Timbrado)' },
                                { id: 'A5', search: 'A5' },
                                { id: 'A5-T', search: 'A5 (Timbrado)' },
                                { id: 'A5-NT', search: 'A5 (Não Timbrado)' },
                            ]"
                            optionsData="id"
                            v-model="pageSize" />

                    <select class="form-control" id="page-size" type="select" v-model="pageSize" v-if="false">
                        <option value="A4">A4</option>
                        <option value="A4-T">A4 (Timbrado)</option>
                        <option value="A4-NT">A4 (Não Timbrado)</option>
                        <option value="A5">A5</option>
                        <option value="A5-T">A5 (Timbrado)</option>
                        <option value="A5-NT">A5 (Não Timbrado)</option>
                    </select>
                    </div>
                    <div class="form-group mb-0 mr-2" v-if="!videoaberto && this.name == 'requisicao'">
                        <az-input 
                        type="button-group"
                        sizing="sm"
                        :optionsList="
                            ( cirurgia && planserv ) 
                            ? [
                                { id: '', search: 'Requisição' }, 
                                { id: 'sus', search: 'SUS' }, 
                                { id: 'tiss-si', search: 'Solic. Intern.' }, 
                                { id: 'tiss', search: 'SP/SADT' }, 
                                { id: 'planserv', search: 'PLANSERV' }, 
                            ]
                            : [
                                { id: '', search: 'Requisição' }, 
                                { id: 'sus', search: 'SUS' }, 
                                { id: 'tiss-si', search: 'Solic. Intern.' }, 
                                { id: 'tiss', search: 'SP/SADT' }, 
                            ]"
                        optionsData="id"
                        v-model="formulario" />

                    <select class="form-control" id="page-size" type="select" v-model="formulario" v-if="false">
                        <option value>Requisição</option>
                        <option value="sus">Formulário SUS</option>
                        <option value="tiss-si">Formulário Solicitação de Internação</option>
                        <option value="tiss">Formulário TISS SP/SADT</option>
                        <option value="planserv" v-if="cirurgia && planserv" >Formulário PLANSERV</option>
                    </select>
                    </div>
                    <div v-if="edicao.items.length">
                    <div class="input-group input-group-sm">
                        <div class="input-group-prepend">
                        <div class="input-group-text">
                            <input
                            type="checkbox"
                            aria-label="Checkbox for following text input"
                            v-model="criarkit"
                            />
                        </div>
                        </div>
                        <input
                        type="text"
                        class="form-control"
                        placeholder="Nome do Kit..."
                        v-model="nomedokit"
                        v-if="criarkit"
                        />
                        <label class="form-control" v-else>Criar novo kit</label>
                    </div>
                    </div>
                </div>
                <div>
                    <az-submit color="danger" @click="remover()" v-if="edicao.model && edicao.model.id">Remover</az-submit>
                    <button type="button" class="btn btn-secondary mx-2" data-dismiss="modal">Fechar</button>
                    <az-submit @click="atualizar (false, false)" color="outline-success mr-2">
                        {{ ( ( edicao && !edicao['id_' + name] ) ? 'Incluir' : 'Atualizar' ) }}
                    </az-submit>
                    <az-submit @click="atualizar ()" v-if="!videoaberto && !edicao.fl_prescricao">
                        {{ ( ( edicao && !edicao['id_' + name] ) ? 'Incluir' : 'Atualizar' ) + ( ( videoaberto || edicao.fl_prescricao ) ? '' : ' e Imprimir' ) }}
                    </az-submit>
                </div>
            </template>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal de Alertas -->
    <div class="modal fade" :id="'alertas' + modal_id" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
      <div class="modal-dialog modal-dialog-scrollable" role="document">
        <div class="modal-content" v-if="alertas">
          <div class="modal-header">
            <h5 class="modal-title">Atenção</h5>
            <button type="button" class="close" @click="fechar_modal('alertas' + modal_id)" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="list-group">
              <a href="#" class="list-group-item list-group-item-action" :class="'list-group-item-' + alerta.color" v-for="(alerta, iax) in alertas.lista" :key="iax">
                <h4>{{ alerta.procedimento }}</h4>
                <div v-if="alerta.msg" style="white-space: pre-wrap;">{{ alerta.msg }} </div>
                <div v-if="alerta.obs" style="white-space: pre-wrap;">{{ alerta.obs }} </div>
              </a>
            </div>
            <pre v-if="false">{{ alertas }}</pre>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="fechar_modal('alertas' + modal_id)">Cancelar</button>
            <az-submit @click="atualizar(true)" :disabled="tem_alerta_block">Confirmar</az-submit>
          </div>
        </div>
      </div>
    </div>

    <unidade-operacao-lista ref="unidadeoperacaolista" @refresh="atualizar_componente" />
  </div>
</template>

<script>
import _ from "lodash";
import $ from "jquery";
import * as moment from "moment";
import AzInput from "../../shared/forms/AzInput.vue";
import AzSubmit from "../../util/AzSubmit.vue";
import AzAuditLogButton from "../../util/AzAuditLogButton.vue";
import Avatar from 'vue-avatar'
import Formulario from './Formulario.vue';
import AzSubTitle from '../../util/AzSubTitle.vue';
import draggable from "vuedraggable";
import OrderSetItem from './OrderSetItem.vue';
import Multiselect from 'vue-multiselect';
import UnidadeOperacaoLista from '../../shared/UnidadeOperacaoLista.vue';

export default {
  data() {
    return {
      novo_item: null,
      novo_hospital: null,
      historico: null,
      validate: false,
      exibir: false,
      videoaberto: false,
      pageSize: "A4",
      edicao: null,
      stats: null,
      criarkit: false,
      nomedokit: "",
      viewMode: "kit",
      exibir_data: true,
      formulario: "",
      medico_procs: null,
      cod_cirurg_obrig: false,
      alertas: null,
      formPorOperadora: false,
      lista_medicos: {},
      opcao_confirm_imp: null,
      index_inclusao: null,
      index_diluente: null,
      procGrupos: null,
      novoOpme: "",
      habilita_ordem: false,
      drag: false,
      search_kit: "",
      block_execucao_imediata: false,
      block_inclusao_procedimento: false,
      block_inclusao_medicamento: false, 
      local_exec: 'E',
      trocando_local_exec: false,
      options_classes: [], 
      apenas_favoritos: false,
      item_unidades: null, 
      vias: [],
      usos: [], 
      imuno_paineis: null, 
    };
  },

  props: [
    "value", 
    "title", 
    "service", 
    "name", 
    "id_paciente", 
    "kit", 
    "id_anamnese", 
    "cirurgia",
    "atendimento", 
    "consulta", 
    "assistprocs", 
    "tem_infusao", 
    "infusao", 
    "receita_medicamento_buscar", 
    "id_unidade_operacao", 
    "validprescr", 
    "cassetes"
  ],

  components: {
    AzInput,
    AzSubmit,
    AzAuditLogButton,
    Avatar,
    Formulario,
    AzSubTitle,
    draggable,
    OrderSetItem,
    Multiselect, 
    UnidadeOperacaoLista, 
  },

  computed: {
    tem_alerta_block: function () { 
        if ( this.alertas && this.alertas.lista && this.alertas.lista.find(item => item.block) ) { 
            return true;
        }

        return false;
    },

    tem_colirios: function () { 
        if ( this.ativos.find(item => item.item.colirios_count) ) { 
            return true;
        }

        return false; 
    },

    lista_classes: function () { 
      if ( !this.lista_ajuda ) { 
        return [];
      }

      return _.uniq(this.lista_ajuda.flatMap(item => item.js_classes ? item.js_classes : [])).sort();
    },

    config_local_exec: function () {
      if ( this.name == 'requisicao' && !this.cirurgia && !this.consulta ) {
        return this.local_exec;
      }

      return 'E';
    },

    is_emergencia: function () {
      if ( !this.atendimento || !this.atendimento.marcacao || !this.atendimento.marcacao.recepcao )
        return false;

      return this.atendimento.marcacao.recepcao.fl_emergencia;
    },

    ativos: {
      get() {
        if (!this.edicao) return [];
        return this.edicao.items.filter((item) => item.fl_ativo);
      },

      set(value) {
        console.log('set', value);
        this.edicao.items = value;
      },

    },

    imc: {
      get() {
        if (!this.edicao || !this.edicao.in_altura ) return;

        return Math.round(this.edicao.in_peso / ( this.edicao.in_altura * this.edicao.in_altura ));
      },

      set(value) {
        this.edicao.imc = value;
      },
    },

    sc: {
      get() {
        if ( !this.edicao || !this.edicao.in_peso || !this.edicao.in_altura )
          return;

        return Math.round(
          Math.sqrt(Number(this.edicao.in_altura * 100) * Number(this.edicao.in_peso) / 3600) * 100
        ) / 100;
      },

      set(value) {
        this.edicao.sc = value;
      },
    },

    lista_usados: function () {
      if (!this.stats || !this.edicao) return [];

      return this.stats[this.name].filter((item) => {
        return !this.edicao.items.find(
          (lanc) => lanc.item.id == item.id && lanc.fl_ativo == 1
        );
      })
      .filter(item => this.name != 'requisicao'
        || ( item.id_classe_procedimento == 1 && this.consulta )
        || ( item.id_classe_procedimento == 2 && this.cirurgia )
        || ( item.id_classe_procedimento > 2 && !this.cirurgia && !this.consulta )
      );
    },

    lista_ajuda: function () {
      if (!this.historico) return null;

      let reg = this.$util.getregex(this.search_kit);

      return this.historico.filter(
        (item) =>
          item.tipo == this.viewMode ||
          (item.tipo == "legado" && this.viewMode == "historico")
      )
      .filter(item => ( this.name != 'requisicao'
            || this.viewMode == "historico"
            || ( item.items.find(proc => proc.item.id_classe_procedimento == 2) && this.cirurgia )
            || ( item.items.find(proc => proc.item.id_classe_procedimento != 2) && !this.cirurgia )
        ) && 
        ( !this.apenas_favoritos || item.favorito )
      )
      .filter(item => !this.search_kit || reg.test(JSON.stringify(item)));
    },

    block_print: function () {
      return this.videoaberto || ( this.edicao && this.edicao.fl_prescricao );
    },

    modal_id: function () {
      return "orderSet" + this.name + "Modal" + this.id_anamnese
        + ( this.cirurgia ? 'cirurgia' : '')
        + ( this.consulta ? 'consulta' : '');
    },

    campo_chave: function () {
      if ( !this.kit ) {
        return 'id_' + this.name;
      }

      return 'id_kit_' + ( this.name == 'requisicao' ? 'procedimento' : 'medicamento' );
    },

    planserv: function() {
      return _.get(this.atendimento, 'plano.operadora.st_registro_ans') == '323274';
    },


    tipos_receita: function() {

      let tipos_receita = [
        { id: 'S', search: 'Receituário Simples' },
        { id: 'A', search: 'Receituário de Antimicrobiano' },
        { id: 'C', search: 'Receituário de Controle Especial' },
        { id: 'L', search: 'LME - Solicitação de Medicamentos' }
      ]

      /*
      if (_.get(this.atendimento, 'plano.operadora.fl_sus')) {
        tipos_receita.push({ id: 'L', search: 'LME - Solicitação de Medicamentos' });
      }
      */

      return tipos_receita;
    }
  },

  methods: {
        selecionar_painel (item, painel) { 
            item.js_classes = painel.js_classes ? _.cloneDeep(painel.js_classes) : [];
            //painel.js_classes.forEach(c => this.addTagComp(item, c));
            //this.$forceUpdate();
        },

        remover_item_lista (lista, idx) { 
            lista.splice(idx, 1);
        },
        
        incluir_cassete (item, cassete) { 

            if ( item.cassetes ) { 
                let busca = item.cassetes.find(c => c.id_amostra == cassete.id_amostra);

                if ( busca ) { 
                    busca.excluido = false;
                    busca.js_classes = item.js_classes ? _.cloneDeep(item.js_classes) : [];
                    this.$forceUpdate();
                    return;
                }
            }

            if ( !item.cassetes ) { 
                item.cassetes = []; 
            }

            item.cassetes.push({
                id_amostra: cassete.id_amostra,
                amostra: cassete,
                js_classes: item.js_classes ? _.cloneDeep(item.js_classes) : [],
                excluido: false, 
            });

            this.$forceUpdate();

        },

        unidade_operacao_lista(item) {
            this.item_unidades = item;
            this.$refs.unidadeoperacaolista.abrir('itemKitMedicamento', item.id_item_kit_medicamento);
        },

        atualizar_componente(item) { 
            if ( item ) { 
                this.item_unidades.unidade_operacao_lista_count = item.length;
            }
        },

        favoritar (item) {
            let model = {
                model_type: "", 
                model_id: null,
            };

            if ( item.id_kit_medicamento ) { 
                model.model_type = 'kitMedicamento';
                model.model_id = item.id_kit_medicamento;
            } else if ( item.id_kit_procedimento ) { 
                model.model_type = 'kitProcedimento';
                model.model_id = item.id_kit_procedimento;
            } else if ( item.id_requisicao ) { 
                model.model_type = 'requisicao';
                model.model_id = item.id_requisicao;
            } else if ( item.id_receita ) { 
                model.model_type = 'receita';
                model.model_id = item.id_receita;
            } else if ( item.id_atendimento ) { 
                model.model_type = 'atendimento';
                model.model_id = item.id_atendimento;
            } else { 
                this.$toast.add({
                    severity: "error",
                    summary: "Favoritar",
                    detail: "Não disponível para esse item.",
                    life: 3000,
                });
                return;
            }

            this.$util.loadItem(this, { 
                service: 'favoritos',
                func: 'favoritar',
                parms: model, 
            })
            .then(res => {
                if ( res ) { 
                    item.favorito = ( res && res.fl_ativo ) ? res : null;
                }
            });
        },

      filtrar (texto) { 
        if ( this.search_kit == '"' + texto + '"' ) { 
            this.search_kit = "";
        } else { 
            this.search_kit = '"' + texto + '"';
        }
      },
      trocar_plano () { 
        if ( this.edicao.plano === null || this.edicao.plano === undefined) { 
          this.edicao.plano = ""; 
        } else { 
          this.edicao.plano = null;
        }
      },

      definir_particular() { 
        if ( this.edicao.plano && this.edicao.plano.id_plano == 1 ) {
            this.edicao.plano = null;   
            return;
        }
        
        this.edicao.plano = { 
            id_plano: 1, 
            st_plano: 'Particular', 
            search: 'Particular', 
            operadora: { id_operadora: 1, st_operadora: 'Particular' }
        };
      },

      addTagComp (item, newTag) { 

        if ( !item.js_classes ) { 
            item.js_classes = [];
        }

        item.js_classes.push(newTag);

      },

      addTag (newTag) {
        this.options_classes.push(newTag);

        if ( !this.edicao.js_classes )
            this.edicao.js_classes = [];

        this.edicao.js_classes.push(newTag);
      },

      selecionar_medico_consulta (proc, medico) { 
        let teste = this.ativos.find(item => item.item.search == proc);

        if ( teste && medico ) { 
          teste.st_observacoes = medico.search;
          teste.id_medico_consulta = medico.id_pessoa;

          this.$forceUpdate();
        }
      },

      set_local_exec (local) {
        this.trocando_local_exec = true;
        this.local_exec = local;

        this.$util.setCookie('cn-le', local, 365);

        this.$nextTick(() => {
          this.trocando_local_exec = false;
        });
      },

      ordenar(tipo) {
        const campo = (tipo == 'A'
          ? 'item.search'
          : 'id_item_kit_' + ( this.name == 'requisicao' ? 'procedimento' : 'medicamento' ));

        this.edicao.items = _.orderBy(this.edicao.items, campo);
        this.$forceUpdate();
      },

      listar_ativos (lista) {
        return lista.filter(item => item.fl_ativo);
      },


      incluir_proc (item) {
        item.item.incluir = true;
        this.$forceUpdate();
      },

      calc_rows (texto) {
        if ( !texto )
          return 1;

        let tem_linhas = /\r|\n/.exec(texto);

        if ( texto.length > 100 || tem_linhas ) {
          return 4;
        }

        return 1;
      },

      incluirOpme () {
        if ( !this.novoOpme )
          return;

        if(typeof this.novoOpme == 'string') {
          this.novoOpme = {
            st_material: this.novoOpme,
            search: this.novoOpme,
            st_descricao: this.novoOpme,
            st_codigo: ''
          }
          
        }

        let novo = _.cloneDeep(this.novoOpme);
        this.novoOpme = "";

        this.edicao.materiais.push({
          id_requisicao_material: null,
          id_material: novo.id_material,
          id_medicamento: novo.id_medicamento,
          fl_ativo: true,
          in_quantidade: 1,
          st_fabricante: "",
          st_descricao: novo.st_descricao,
          st_codigo: novo.st_codigo,
          material: novo,
          medicamento: novo, 
        });

        this.$nextTick(() => {
          this.novoOpme = null;
        });

    },

    toggle_sort(kit) {
      kit.alpha_sorted = ( kit.alpha_sorted ? false : true );
      this.$forceUpdate();
    },

    selecionar_grupo(item, grupo) {
      if ( item.item.id_procedimento_grupo == grupo.id_procedimento_grupo && !item.fl_imprimir_separado ) {
        item.item.id_procedimento_grupo = null;
        item.item.grupo = null;
      } else {
        item.fl_imprimir_separado = false;
        item.item.id_procedimento_grupo = grupo.id_procedimento_grupo;
        item.item.grupo = grupo;
      }
    },

    incluir_antes(index, index_diluente = null) {
      this.index_inclusao = ( this.index_inclusao == index ? null : index )
      this.index_diluente = this.index_inclusao ? index_diluente : null;
    },

    verificar_medicos_consulta(procedimento) {
      this.$util.loadItem(this, {
        service: 'medicos',
        func: 'de_especialidades',
        parms: {
          id_procedimento: procedimento.id_procedimento,
        }
      })
      .then(res => {
        this.$set(this.lista_medicos, procedimento.search, res);
      });
    },

    fechar_modal(modal) {
      $('#' + modal).modal('hide');
    },

    item_formula (item) {
      return item.apresentacao && item.apresentacao.id_apresentacao == 49;
    },

    removerKit() {
      if (!confirm("Confirma remover esse kit?")) return;

      this.$util.atualizar(this, {
        service: "pep",
        func: "remover_kit",
        dados: {
          type: this.name,
          dados: this.edicao,
        },
        callback: () => {
          $(".modal").modal("hide");
          this.$emit("refresh", null);
        },
      });
    },

    remover() {
      if (!confirm("Confirma remover esse registro?")) return;

      this.$util.atualizar(this, {
        service: "pep",
        func: "item_remover",
        dados: {
          model_type: this.edicao.model.type,
          model_id: this.edicao.model.id,
        },
        callback: () => {
          $(".modal").modal("hide");
          this.$emit("refresh", null);
        },
      });
    },

    getFormatDate(date, format) {
      return moment(date, "YYYY-MM-DD").format(format);
    },

    historico_flat(hist) {
      let self = this;
      let items;

      if (hist.tipo == "legado") {
        items = hist.items;
      } else if (hist.id_atendimento) {
        items = _.flatMap(hist.atendimento_procedimentos, (item) => {
          return _.flatMap(item.anamnese[self.name], (item) => {
            return item.items;
          });
        });
      } else {
        items = hist.items;
      }

      items = items.filter(item => this.name != 'requisicao'
        || ( item.item.id_classe_procedimento == 2 && this.cirurgia )
        || ( item.item.id_classe_procedimento != 2 && !this.cirurgia )
      );

      return hist.alpha_sorted
        ? _.sortBy(items, item => ( item && item.item ) ? item.item.search : '')
        : items;
    },

    incluir_items(lista) {
      lista = _.cloneDeep(lista);

      if ( lista.in_diarias && !this.edicao.in_diarias ) {
        this.edicao.in_diarias = lista.in_diarias;
      }

      if ( lista.in_regime_internacao && !this.edicao.in_regime_internacao ) {
        this.edicao.in_regime_internacao = lista.in_regime_internacao;
      }

      if ( lista.st_indicacao_clinica && !this.edicao.st_indicacao_clinica ) {
        this.edicao.st_indicacao_clinica = lista.st_indicacao_clinica;
      }

      if ( lista.cid && !this.edicao.cid ) {
        this.edicao.cid = lista.cid;
      }

      if ( lista.cid2 && !this.edicao.cid2 ) {
        this.edicao.cid2 = lista.cid2;
      }

      if ( lista.cid3 && !this.edicao.cid3 ) {
        this.edicao.cid3 = lista.cid3;
      }

      //if ( lista.id_kit_procedimento ) {

        if ( lista.st_observacoes ) { 
          this.edicao.st_observacoes = lista.st_observacoes;
        }

        if ( lista.st_observacoes_interno ) { 
          this.edicao.st_observacoes_interno = lista.st_observacoes_interno;
        }

      //}

      if ( lista && lista.fl_ciclos ) {
        this.edicao.fl_ciclos = true;
        this.edicao.in_ciclos = lista.in_ciclos;
        this.edicao.in_intervalo = lista.in_intervalo;
        this.edicao.in_duracao = lista.in_duracao;
        this.edicao.in_tempo_sessao = lista.in_tempo_sessao;
        this.edicao.id_procedimento_protocolo = lista.id_procedimento_protocolo;

        if ( lista.st_tipo == 'Q' || lista.st_tipo == 'U' ) { 
          this.edicao.st_tipo_receita = lista.st_tipo;
        }

        if ( lista.id_kit_medicamento ) {
          
          this.edicao.id_kit_medicamento = lista.id_kit_medicamento;
          this.edicao.kit = {
            id_kit_medicamento: lista.id_kit_medicamento,
            search: lista.search,
          };

        } 

        this.$nextTick(() => {
          this.$forceUpdate();
        });
      }

      if ( lista.materiais ) {
        if ( !this.edicao.materiais || !this.edicao.materiais.length ) {
          this.edicao.materiais = lista.materiais.map(material => {
            material.id_requisicao_material = null;
            return material;
          });
        } else {
          lista.materiais.forEach((material) => {
            material.id_requisicao_material = null;
            this.edicao.materiais.push(material);
          });
        }
      }

      let items = this.historico_flat(lista);

      items.forEach((item) => {
        if (
          this.ativos.findIndex(
            (lanc) =>
              (
                this.name == "receita" &&
                item.item.id_medicamento &&
                lanc.item.id_medicamento == item.item.id_medicamento &&
                ( !lanc.id_kit || lanc.id_kit == item.id_kit_medicamento ) &&
                1 == 0
              ) ||
              (
                this.name == "requisicao" &&
                lanc.item.id_procedimento == item.item.id_procedimento
              )
          ) < 0
        ) {

          if ( item.item ) { 
            item.item.st_agrupa = item.st_agrupa;
          }

          this.incluir_item(item);

        }
      });

    },

    incluir_hospital() {
      if (!this.novo_hospital) {
        return;
      }

      if (typeof this.novo_hospital == "string") {
          this.edicao.st_hospital = this.novo_hospital;
          this.edicao.id_centro_cirurgico = null;
      } else {
          this.edicao.st_hospital = null;
          this.edicao.id_centro_cirurgico = this.novo_hospital;
      }
    },

    incluir_item(item = null, index = null) {
      if (!item && !this.novo_item) {
        return;
      }

      let execucao_imediata = null;

      let novo_item;

      if (item) {
        let selec = _.cloneDeep(item.item);

        novo_item = {
          ...selec,
          fl_texto_editado: item.fl_texto_editado ? true : false,
          st_texto_impressao: item.st_texto_impressao,
        };

        if ( item.st_agrupa ) { 
          novo_item.st_agrupa = item.st_agrupa;
        }

        let obs = item.st_observacoes ? item.st_observacoes : item.st_observacao;

        if ( !obs ) { 
          obs = selec.st_obs ? selec.st_obs : "";
        }

        if ( selec ) { 
            if ( item.id_prescricao_uso ) { 
                selec.id_prescricao_uso = item.id_prescricao_uso;
            }

            if ( item.id_prescricao_via ) { 
                selec.id_prescricao_via = item.id_prescricao_via;
            }
        }

        item = selec
          ? {
              ...selec,
              st_observacoes: obs,
              id_apresentacao: item.id_apresentacao,
              st_posologia: item.st_posologia,
              in_quantidade: item.in_quantidade,
              apresentacao: item.apresentacao,
              fl_texto_editado: item.fl_texto_editado ? true : false,
              st_texto_impressao: item.st_texto_impressao,
              diluidos: item.diluidos,
              st_ciclo_dias: item.st_ciclo_dias, 
              st_agrupa: item.st_agrupa, 
            }
          : {};
      } else {
        novo_item = this.novo_item;
        item = this.novo_item;
      }

      if (novo_item) {
        if (typeof novo_item == "string") {
          const descricao = item.substr(-4,4).toUpperCase() == 'NOVO'
            ? item.substr(0,item.length - 5).trim()
            : item;

          novo_item = {
            id_medicamento: null,
            search: descricao,
            st_medicamento: descricao,
            st_posologia: "",
            incluir: true,
            id_procedimento_grupo: null,
            grupo: null,
            fl_imprimir_separado: false,
            st_agrupa: "", 
            id_med_dil: "", 
          };
        } else {
          novo_item.incluir = false;
        }

        if ( this.name == "requisicao" && !this.block_execucao_imediata ) {
          if ( this.medico_procs && this.medico_procs.find(mp => mp.id_procedimento == novo_item.id_procedimento
            || mp.id_procedimento == novo_item.id_procedimento_cobranca ) ) {

            execucao_imediata = false; // this.is_emergencia ? true : false;

          }
        }

        let obs = item.st_observacoes ? item.st_observacoes : item.st_observacao;

        if ( !obs && novo_item ) { 
          obs = novo_item.st_obs ? novo_item.st_obs : "";
        }

        const item_add = {
          id_receita: null,
          id_receita_medicamento: null,
          item: _.cloneDeep(novo_item),
          st_posologia: item.st_posologia,
          in_quantidade: item.in_qtde_default ? item.in_qtde_default : item.in_quantidade,
          id_apresentacao: item.id_apresentacao,
          apresentacao: item.apresentacao,
          st_observacoes: obs,
          fl_ativo: true,
          fl_imprimir_separado: novo_item.fl_imprimir_separado ? true : false,
          fl_execucao_imediata: execucao_imediata,
          st_codigo: novo_item.st_codigo_cbhpm,
          st_texto_impressao: ( novo_item && novo_item.fl_texto_editado && novo_item.st_texto_impressao )
            ? novo_item.st_texto_impressao
            : (
              ( novo_item && novo_item.fl_permite_editar_texto && novo_item.st_texto_requisicao )
                ? novo_item.st_texto_requisicao
                : ""
            ),
          fl_texto_editado: novo_item ? ( novo_item.fl_permite_editar_texto || novo_item.fl_texto_editado ) : false,
          index_diluente: this.index_diluente,
          diluidos: item.diluidos ? item.diluidos : [],
          st_ciclo_dias: item.st_ciclo_dias, 
          st_agrupa: novo_item.st_agrupa,
          id_prescricao_uso: ( ( item && item.id_prescricao_uso ) ? item.id_prescricao_uso : "" ), 
          id_prescricao_via: ( ( item && item.id_prescricao_via ) ? item.id_prescricao_via : "" ), 
          id_med_dil: ( ( item && item.id_med_dil ) ? item.id_med_dil : "" ),
          js_classes: [], 
        };

        // Verificação do código...

        if ( this.value.fl_cirurgia ) {

          this.$util.loadItem (this, {
            service: 'procedimentos',
            func: 'valor',
            parms: {
                ...item_add.item,
                id_plano: this.atendimento.id_plano,
                index: -1,
                lista: [],
                id_guia: null,
            },
          })
          .then(res => {
            if ( _.get(res, 'valor.item_tabela.st_codigo') ) {
              item_add.st_codigo = _.get(res, 'valor.item_tabela.st_codigo');
            }
          });

        }

        if ( ( this.index_diluente === 0 || this.index_diluente ) && _.get(this.edicao.items, this.index_diluente) ) {
          item_add.st_ciclo_dias = this.edicao.items[this.index_diluente].st_ciclo_dias;

          this.edicao.items[this.index_diluente].diluidos.push(item_add);

        } else {

          if ( ( index || index === 0 ) && ( index === this.index_inclusao || index === this.index_diluente ) ) {
            this.edicao.items.splice(index, 0, item_add);
            this.index_inclusao = this.index_inclusao + 1;

            this.$nextTick(() => {
              this.$refs.search_antes.$refs.input.focus();
            });
          } else {
            if ( item_add && item_add.item && item_add.item.fl_controle_especial ) {
              this.edicao.st_tipo_receita = 'C';
            }

            this.edicao.items.push(item_add);
          }

        }

        if ( this.consulta ) {
          this.verificar_medicos_consulta(novo_item);
        }

        this.$nextTick(() => {
          if (this.novo_item !== null) {
            this.novo_item = null;
          }
        });
      }
    },

    excluirItem(item) {
      this.index_inclusao = null;
      this.index_diluente = null;
      item.fl_ativo = false;
      /*
      if (
        item.id_receita_medicamento ||
        item.id_requisicao_procedimento ||
        item.id_item_kit_medicamento ||
        item.id_item_kit_procedimento
      ) {
        //this.$set(lista[index], 'fl_ativo', false);
        item.fl_ativo = false;
        this.$forceUpdate();
      } else {
        lista.splice(index, 1);
      }
      */
    },

    abrir(item = null, lista = null) {
      this.habilita_ordem = false;
      this.exibir = false;
      this.formPorOperadora = false;
      this.index_inclusao = null;
      this.index_diluente = null;
      this.lista_medicos = {};

      this.historico = null;

      this.$nextTick(() => {

        this.pageSize = this.$util.getCookie("page-size");

        if (!this.pageSize) this.pageSize = "A4";

        this.videoaberto = $("#video-aberto").length ? true : false;

        this.nomedokit = "";
        this.criarkit = false;
        this.validate = false;

        this.novo_hospital = item ? item.id_centro_cirurgico : "";

        this.edicao = _.cloneDeep(item ? item : this.value);
        this.stats = _.cloneDeep(this.$store.state.options.order_set_stats);

        if ( item && !item.requisicao && lista ) { 
          this.incluir_items(lista);
        }

        if ( !item && this.infusao ) {
          this.edicao.fl_ciclos = true;
        }

        this.exibir = true;
        let modal = "#" + this.modal_id;

        $(modal).modal("show");

        let self = this;

        if ( !this.kit ) { 
          $(modal).on("shown.bs.modal", function () {
            self.focusOn("order_set_search_" + self.name);
          });
        }

        if (this.id_paciente ) {  // && !this.medico_procs

          let query = {
            q: [
              {
                name: "pep.historico_" + this.name,
                id: "historico",
                parms: {
                  id: this.id_paciente,
                  id_atendimento: this.atendimento ? this.atendimento.id_atendimento : null, 
                  id_unidade_operacao: this.id_unidade_operacao,
                  cirurgia: this.cirurgia,
                  prescricao: this.edicao.fl_prescricao,
                },
              },
              {
                name: "medico_procedimento_unidades.index",
                id: "medico_procs",
                parms: {
                  id_medico: this.$store.state.user.medico ? this.$store.state.user.id_pessoa : ( this.atendimento ? this.atendimento.id_medico : -1 ),
                  cirurgia: this.cirurgia,
                  pep: true,
                },
              },
              {
                name: "configuracoes.index",
                id: "config",
                parms: {
                  where: {
                    st_slug: 'solic-cirurg-cod-obrig',
                  },
                },
              },
              {
                name: "configuracoes.index",
                id: "bei",
                parms: {
                  where: {
                    st_slug: 'block-execucao-imediata',
                  },
                },
              },
              {
                name: "configuracoes.index",
                id: "bnovo",
                parms: {
                  where: {
                    st_slug: 'block-requisicao-inclusao-procedimento',
                  },
                },
              },
              {
                name: "configuracoes.index",
                id: "bnovor",
                parms: {
                  where: {
                    st_slug: 'block-receita-inclusao-medicamento',
                  },
                },
              },
              {
                name: "operadoras.config",
                id: "configguia",
                parms: {
                  regans: _.get(this.atendimento, 'plano.operadora.st_registro_ans'),
                  slug: 'req-guia-sadt',
                },
              }
            ],
          };

          if ( this.cassetes && this.cassetes.length ) { 
            query.q.push({
              name: "imuno_paineis.index",
              id: "imuno_paineis",
              parms: {
                cadastro: false, 
              },
            });
          }

          if ( this.procGrupos === null && this.name == 'requisicao' ) {
            query.q.push({
                name: "procedimento_grupos.index",
                id: "grupos",
              });
          }

          if ( this.name == 'receita' && this.value && ( this.value.fl_prescricao || this.kit ) ) { 
                query.q.push({
                    name: "prescricao_vias.index",
                    id: "vias",
                    parms: {
                    ativos: true,
                    },
                });

                query.q.push({
                    name: "prescricao_usos.index",
                    id: "usos",
                    parms: {
                        ativos: true,
                    },
                });

                query.q.push({
                    name: "configuracoes.index",
                    id: "bprescricao",
                    parms: {
                        where: {
                            st_slug: 'escopo-prescricao-restrito',
                        },
                    },
                });              
          }

          this.axios.post("/aql?a=pep.historico_" + this.name, query).then((res) => {
            if (res.data.historico.status == 200) {
              this.historico = res.data.historico.data;
            }

            if ( res.data.imuno_paineis && res.data.imuno_paineis.status == 200 ) { 
              this.imuno_paineis = res.data.imuno_paineis.data;
            }

            if (res.data.grupos && res.data.grupos.status == 200) {
              this.procGrupos = res.data.grupos.data;
            }

            if (res.data.medico_procs.status == 200) {
              this.medico_procs = res.data.medico_procs.data;

              if ( this.name == 'requisicao' && this.ativos && this.ativos.length ) {
                this.ativos.filter(item => !item.id_requisicao_procedimento)
                  .forEach(item => {
                    if ( this.medico_procs && this.medico_procs.find(mp => mp.id_procedimento == item.item.id_procedimento
                       || mp.id_procedimento == item.item.id_procedimento_cobranca ) ) {

                      item.fl_execucao_imediata = false;

                    }
                  });
              }
            }

            if (res.data.config.status == 200) {
              this.cod_cirurg_obrig = ( _.get(res.data.config.data, '0.st_valor') == 1 ) ;
            }

            if (res.data.bei && res.data.bei.status == 200) {
              this.block_execucao_imediata = ( _.get(res.data.bei.data, '0.st_valor') == 1 ) ;
            }

            if (res.data.vias && res.data.vias.status == 200) {
              this.vias = res.data.vias.data; 
            }

            if (res.data.usos && res.data.usos.status == 200) {
              this.usos = res.data.usos.data; 
            }

            if (this.name == 'requisicao' && res.data.bnovo && res.data.bnovo.status == 200) {
              this.block_inclusao_procedimento = ( _.get(res.data.bnovo.data, '0.st_valor') == 1 ) ;
              // this.edicao.st_carater_atendimento = 'E';
            } else { 
                this.block_inclusao_procedimento = false;
            }

            if (this.name == 'receita' && res.data.bnovor && res.data.bnovor.status == 200) {
                this.block_inclusao_medicamento = ( _.get(res.data.bnovor.data, '0.st_valor') == 1 ) ;
            } else { 
                this.block_inclusao_medicamento = false;
            }

            if ( this.name == 'receita' && res.data.bprescricao && res.data.bprescricao.status == 200 ) {
                if ( _.get(res.data.bprescricao.data, '0.st_valor') == 1 ) { 
                    this.block_inclusao_medicamento = true;
                }
            }

            if( res.data.configguia.status == 200 && res.data.configguia.data ) {
              this.formPorOperadora = true;
              this.formulario = 'tiss';
            }

          });
        } else if ( this.procGrupos === null && this.name == 'requisicao' ) { 

          let query = {
            q: [
              {
                name: "procedimento_grupos.index",
                id: "grupos",
              }
            ]
          };

          if ( this.cassetes && this.cassetes.length ) { 
            query.q.push({
              name: "imuno_paineis.index",
              id: "imuno_paineis",
              parms: {
                cadastro: false, 
              },
            });
          }

          this.axios.post("/aql?a=pep.historico_" + this.name, query).then((res) => {
            if (res.data.grupos && res.data.grupos.status == 200) {
              this.procGrupos = res.data.grupos.data;
            }

            if ( res.data.imuno_paineis && res.data.imuno_paineis.status == 200 ) { 
              this.imuno_paineis = res.data.imuno_paineis.data;
            }
          });

        } else if ( this.name == 'receita' && this.kit ) { 

            let query = { q: [] };

            query.q.push({
                name: "prescricao_vias.index",
                id: "vias",
                parms: {
                ativos: true,
                },
            });

            query.q.push({
                name: "prescricao_usos.index",
                id: "usos",
                parms: {
                    ativos: true,
                },
            });

            this.axios.post("/aql?a=pep.historico_" + this.name, query).then((res) => {
                if (res.data.vias && res.data.vias.status == 200) {
                   this.vias = res.data.vias.data; 
                }

                if (res.data.usos && res.data.usos.status == 200) {
                    this.usos = res.data.usos.data; 
                }
            });

        }

      });

    },

    focusOn(item) {
      this.$refs[item].$refs.input.focus();
    },

    atualizar(confirmado = false, imprimir = true, assistproc = null) {
      this.habilita_ordem = false;

      if ( confirmado )
        imprimir = this.opcao_confirm_imp;
      else
        this.opcao_confirm_imp = imprimir;

      if (this.criarkit && !this.nomedokit && this.edicao.items.length) {
        this.$toast.add({
          severity: "error",
          summary: "Atenção",
          detail: "Informe o nome do kit.",
          life: 3000,
        });
        return;
      }

      if ( !this.formPorOperadora ) {
        this.$util.setCookie('form-req-' + ( this.cirurgia ? 'cirurg' : 'proced'), this.formulario);
      }

      this.validate = true;
      const modal = "#" + this.modal_id;
      const alertasmodal = "#" + 'alertas' + this.modal_id;

      this.$nextTick(() => {
        let invalids = $(modal + " .invalid");

        if (invalids.length && $(".invalid").is(":visible")) {
          this.$toast.add({
            severity: "error",
            summary: "Atenção",
            detail: "Verificar preenchimento dos campos.",
            life: 3000,
          });
          return;
        }

        this.$store.commit("loading", true);

        let query = {
          q: [
            {
              name: "pep.salvar_order_set" + (this.kit ? "_kit" : ""),
              id: "orderset",
              parms: {
                type: this.name,
                dados: this.edicao,
                criarkit: this.criarkit,
                nomekit: this.nomedokit,
                kit: this.kit,
                confirmado: confirmado,
                modelo: this.formulario,
                validprescr: this.validprescr, 
              },
            },
          ],
        };

        this.axios
          .post("/aql", query)
          .then((res) => {
            if (res.data.orderset.status == 200) {

              if (res.data.orderset.data.alertas ) {
                this.alertas = res.data.orderset.data;
                $('#alertas' + this.modal_id).modal('show');

                // Quantidade default...

                let alerta_qt = this.alertas.lista.filter(alerta => alerta.tipo == 'Q');

                alerta_qt.forEach(alerta => {
                  let index = this.edicao.items.findIndex(item => item.fl_ativo && item.item && item.item.id_procedimento == alerta.id);

                  if ( index >= 0 ) {
                    this.edicao.items[index].in_quantidade = alerta.qtd;
                    this.edicao.items[index].qt_conf = true;
                    this.edicao.items[index].id_restricao_operadora = alerta.id_restricao_operadora;
                  }
                });

                // Quebra na guia...

                let separados = this.alertas.lista.filter(alerta => alerta.tipo == 'B');

                separados.forEach(alerta => {
                  let index = this.edicao.items.findIndex(item => item.fl_ativo && item.item && item.item.id_procedimento == alerta.id);

                  if ( index >= 0 ) {
                    this.edicao.items[index].fl_imprimir_separado = true;
                    this.edicao.items[index].sep_conf = true;
                    this.edicao.items[index].id_restricao_operadora = alerta.id_restricao_operadora;
                  }
                });

                return;
              }

              if (!this.kit)
                this.$util.setCookie(
                  this.name + "-exibir-data",
                  this.edicao.fl_exibir_data ? "S" : "N"
                );

              $(alertasmodal).modal("hide");

              if ( !assistproc ) {
                $(modal).modal("hide");
              }

              const optname = this.service + ".pep" + ( this.cirurgia ? '.cirurgia' : '' );

              if (
                this.edicao.items.find(
                  (item) =>
                    item.item &&
                    !item.item.id_medicamento &&
                    !item.item.id_procedimento
                )
              ) {
                this.$store.commit("deleteOptions", optname);
                this.exibir = false;
              }

              if (this.exibir && this.$store.state.options[optname]) {
                let lista = _.cloneDeep(this.$store.state.options[optname]);

                this.edicao.items.forEach((item) => {
                  if (
                    this.exibir &&
                    (item.item.id_procedimento || item.item.id_medicamento)
                  ) {
                    let foundindex = lista.findIndex(
                      (op_item) =>
                        op_item.id ==
                        (item.item.id_procedimento
                          ? item.item.id_procedimento
                          : item.item.id_medicamento)
                    );

                    if (foundindex >= 0) {
                      if (
                        !(
                          lista[foundindex].fl_imprimir_separado &&
                          item.item.fl_imprimir_separado
                        ) ||
                        !(
                          !lista[foundindex].fl_imprimir_separado &&
                          !item.item.fl_imprimir_separado
                        )
                      ) {
                        this.$store.commit("deleteOptions", optname);
                        this.exibir = false;
                      }
                    }
                  }
                });
              }

              if (!this.block_print) {
                this.$util.setCookie("page-size", this.pageSize, 365);
                this.edicao.pageSize = this.pageSize;
              }

              res.data.orderset.data.modelo = this.formulario;

              if (this.edicao.fl_prescricao && !this.edicao.id_receita ) { 
                this.$emit('validar_ativas');
              }

              this.$emit(
                "refresh",
                ( this.block_print || !imprimir ) ? null : res.data.orderset.data
              );

              if ( assistproc ) {
                this.$store.commit("loading", false);

                this.$nextTick(() => {
                  this.$emit('proximo', assistproc);
                  $(modal).modal("show");
                });
              }
            }
          })
          .finally(() => {
            this.$store.commit("loading", false);
          });
      });
    },
  },

  beforeMount() {
    let local_exec = this.$util.getCookie('cn-le');

    if ( local_exec && ( local_exec == 'I' || local_exec == 'E') ) {
      this.local_exec = local_exec;
    }
  },

  mounted() {
    this.formulario = this.$util.getCookie('form-req-' + ( this.cirurgia ? 'cirurg' : 'proced'));

    if ( this.kit ) { 

      this.$util.loadItem(this, { 
        service: this.name == 'receita' ? 'kit_medicamentos' : 'kit_procedimentos',
        func: 'tags',
      })
      .then(res => { 
        this.options_classes = res;
      });

    }

  },

  updated() {
    $('[data-toggle="tooltip"]').tooltip();
  }
};
</script>

<style scoped>
.modal-dialog-total {
  top: 0;
  width: 100% !important;
  height: 100% !important;
  padding: 0 !important;
  max-width: 100% !important;
  max-height: 100% !important;
  margin-top: 0px;
  margin-bottom: 0px;
  margin: 0px !important;
}

.modal-content-total {
  height: 100% !important;
  max-height: 100% !important;
}
</style>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
